import { firebaseConfig } from "./credentials";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  getCountFromServer,
  collection,
  getDocs,
  orderBy,
  where,
  query,
  FieldValue,
} from "firebase/firestore";
import { getAuth, signInWithPopup, GoogleAuthProvider, getIdTokenResult } from "firebase/auth";
import { getFunctions, httpsCallable } from 'firebase/functions';
const DEVMODE = true;
let firebaseLogger;

export const initFirebase = () => {
  firebase.initializeApp(firebaseConfig);
  firebaseLogger = httpsCallable(getFunctions(), 'logData');
  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);

  /*
    firebase.firestore().enablePersistence().catch((err) => {
        // console.log(err)
    });
     */
};

export const listenAuthorization = (callback) => {
  return firebase.auth().onAuthStateChanged((user) => {
    if (DEVMODE) {
      console.log("1 read, listenAuthorization");
    }
    if (user) {
      if (user.isAnonymous) {
        let account = {};

        account["accountID"] = user.uid;
        account["accountEmail"] = "";
        account["accountFirstName"] = "Anonymous";
        account["accountLastName"] = "";
        account["accountType"] = "student";

        callback(account);
      } else {
        firebase
          .app()
          .firestore()
          .collection("accounts")
          .doc(user.email)
          .get()
          .then((userDoc) => {
            let account = {};
            if (userDoc.exists) {
              account["accountID"] = userDoc.id;
              account["accountEmail"] = userDoc.id;
              account["accountFirstName"] = userDoc.get("firstName");
              account["accountLastName"] = userDoc.get("lastName");
              account["accountType"] = userDoc.get("type");
              account["accountAdmin"] = userDoc.get("admin");
              // account["accountIdentifier"] = userDoc.get("identifier");
            } else {
              account["accountID"] = user._delegate.email;
              account["accountEmail"] = user._delegate.email;
              account["accountFirstName"] =
                user._delegate.displayName.split(" ")[0] || "";
              account["accountLastName"] =
                user._delegate.displayName.split(" ")[1] || "";
              account["accountType"] = "student";
            }

            callback(account);
          });
      }
    }
  });
};

export const handleSignInWithGoogle = async () => {
  if (DEVMODE) {
    console.log("1 read, googleSign in");
  }
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    prompt: "select_account",
  });
  const auth = getAuth();

  return new Promise((resolve, reject) => {
    signInWithPopup(auth, provider)
      .then((accountDetails) => {
        const { user } = accountDetails;
        firebase
          .app()
          .firestore()
          .collection("accounts")
          .doc(user.email)
          .get()
          .then((userDoc) => {
            if (userDoc.exists) {

              if (userDoc.get("type") === "instructor" && userDoc.get("manuallyAdded")) {
                firebase
                  .app()
                  .firestore()
                  .collection("accounts")
                  .doc(user.email)
                  .update({
                    firstName: user?.displayName?.split(" ")[0] || "N/A",
                    lastName: user?.displayName?.split(" ")[1] || "N/A",
                    manuallyAdded: false,
                  }).then(() => {
                    let account = {};
                    account["accountID"] = userDoc.id;
                    account["accountEmail"] = userDoc.id;
                    account["accountFirstName"] = user?.displayName?.split(" ")[0] || "N/A";
                    account["accountLastName"] = user?.displayName?.split(" ")[1] || "N/A";
                    account["accountType"] = userDoc.get("type");
                    account["accountAdmin"] = userDoc.get("admin");
                    resolve(account);
                  });
              } else {
                let account = {};
                account["accountID"] = userDoc.id;
                account["accountEmail"] = userDoc.id;
                account["accountFirstName"] = userDoc.get("firstName");
                account["accountLastName"] = userDoc.get("lastName");
                account["accountType"] = userDoc.get("type");
                account["accountAdmin"] = userDoc.get("admin");
                resolve(account);
              }
            } else {
              firebase
                .app()
                .firestore()
                .collection("courses")
                .where("tas", "array-contains", user.email)
                .get()
                .then((results) => {
                  let account = {};
                  account["accountID"] = user?.email || "N/A";
                  account["accountEmail"] = user?.email || "N/A";
                  account["accountFirstName"] = user?.displayName?.split(" ")[0] || "N/A";
                  account["accountLastName"] = user?.displayName?.split(" ")[1] || "N/A";
                  account["accountType"] = "student";

                  if (results.size > 0) {
                    account["accountType"] = "ta";
                    firebase
                      .app()
                      .firestore()
                      .collection("accounts")
                      .doc(user.email)
                      .set({
                        firstName: account.accountFirstName,
                        lastName: account.accountLastName,
                        type: account.accountType,
                      })
                      .then(() => {
                        resolve(account);
                      });
                  }
                  resolve(account);
                })
            }
          });
      })
      .catch((err) => {
        if (err.code === "auth/popup-closed-by-user") {
          if (DEVMODE) {
            console.log("Authentication popup closed by the user");
          }
        } else {
          if (DEVMODE) {
            console.error("Error getting document:", err);
          }
        }
        reject(err);
      });
  });
};

// GOOGLE DRIVE API FUNCTIONALITIES
export const initGoogleApi = () => {
  return new Promise((resolve, reject) => {
    window.gapi.load("client", () => {
      window.gapi.client
        .init({
          apiKey: "AIzaSyACjxmhtN3j4SoCfp0U0vA_hGn-aZSv19Y",
          clientId:
            "134399078405-somaaqptj2muta7nks03t72n4rcfh7e9.apps.googleusercontent.com",
          scope: "https://www.googleapis.com/auth/drive.file",
        })
        .then(() => {
          if (DEVMODE) {
            console.log("Google API Client initialized");
          }
          resolve();
        })
        .catch((error) => {
          if (DEVMODE) {
            console.error("Error initializing Google API Client:", error);
          }
          reject(error);
        });
    });
  });
};

// export const requestGoogleDriveAccess = () => {
//   return new Promise((resolve, reject) => {
//     const authInstance = window.gapi.auth2.getAuthInstance();

//     if (authInstance.isSignedIn.get()) {
//       // Request additional scopes for Google Drive
//       authInstance.currentUser
//         .get()
//         .grant({
//           scope: "https://www.googleapis.com/auth/drive.file",
//         })
//         .then(() => {
//           if (DEVMODE) {
//             console.log("Google Drive access granted");
//           }
//           resolve();
//         })
//         .catch((error) => {
//           if (DEVMODE) {
//             console.error("Error granting Google Drive access:", error);
//           }
//           reject(error);
//         });
//     } else {
//       console.log("Signing in");
//       // Sign in first if not signed in
//       authInstance
//         .signIn({
//           scope: "https://www.googleapis.com/auth/drive.file",
//         })
//         .then(() => {
//           if (DEVMODE) {
//             console.log("Google Drive access granted");
//           }
//           resolve();
//         })
//         .catch((error) => {
//           if (DEVMODE) {
//             console.error("Error signing in for Google Drive access:", error);
//           }
//           reject(error);
//         });
//     }
//   });
// };
var folderOwner;

export const requestGoogleDriveAccess = (info) => {
  const courseID = info.courseID;
  const user = info.user;
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .get()
      .then((courseDoc) => {

        if (courseDoc.exists) {
          folderOwner = courseDoc.get("folderOwner") ?? user;
          firebase
            .firestore()
            .collection("accounts")
            .doc(folderOwner)
            .get()
            .then((userDoc) => {
              var refreshToken;

              if (userDoc.exists) {
                refreshToken = userDoc.get("refreshToken");
              }
        
              if (refreshToken === undefined) {
                const tokenClient = window.google.accounts.oauth2.initCodeClient({
                  client_id: "134399078405-somaaqptj2muta7nks03t72n4rcfh7e9.apps.googleusercontent.com",
                  scope: "https://www.googleapis.com/auth/drive.file",
                  ux_mode: "popup",
                  callback: (response) => {
                    console.log(response);
                    if (response.code !== undefined) {
                      
                      const params = new URLSearchParams({
                        grant_type: "authorization_code",
                        code: response.code,
                        client_id: "134399078405-somaaqptj2muta7nks03t72n4rcfh7e9.apps.googleusercontent.com",
                        client_secret: "WvpPaNpDft2ChfPY6kTuZN0O",
                        redirect_uri: window.location.origin,
                      });
                      fetch("https://oauth2.googleapis.com/token?" + params,
                        {
                          method: "POST",
                        },
                      ).then((tokens) => {
                        if (!tokens.ok) {
                          throw new Error("Did not recieve refresh token");
                        }
                        return tokens.json();
                      }).then((data) => {
                        firebase
                          .firestore()
                          .collection("accounts")
                          .doc(user)
                          .update({
                            refreshToken: data.refresh_token,
                          }).then(() => {
                            firebase
                              .firestore()
                              .collection("courses")
                              .doc(courseID)
                              .update({
                                folderOwner: folderOwner,
                              }).then(() => {
                                resolve();
                              }).catch((error) => {
                                console.log(error);
                              });
                          });
                      });
                    }
                  },
                });
                tokenClient.requestCode();
              } else {
                resolve();
              }
            });
        }  
      });
  
    // tokenClient = window.google.accounts.oauth2.initTokenClient({
    //   client_id: "134399078405-somaaqptj2muta7nks03t72n4rcfh7e9.apps.googleusercontent.com",
    //   scope: "https://www.googleapis.com/auth/drive.file",
    //   access_type: "offline",
    //   hint: email,
    //   prompt: '',
    //   callback: (response) => {
    //     console.log("CALLBACK");
    //     console.log(response);
    //     resolve();
    //   },
    // });
    // tokenClient.requestAccessToken();
    // if (window.gapi.client.getToken() === null) {
    //   // Prompt the user to select a Google Account and ask for consent to share their data
    //   // when establishing a new session.
    //   console.log("RIP");
    //   tokenClient.requestAccessToken();
    // } else {
    //   console.log("ALL GPPD");
    //   // Skip display of account chooser and consent dialog for an existing session.
    //   tokenClient.requestAccessToken();
    // }
  });
};

export const addCourseDriveFolder = (async(folderData) => {
  await firebase
    .firestore()
    .collection("courses")
    .doc(folderData.courseID)
    .update({
      googleDriveFolderID: folderData.googleDriveFolderID,
      folderOwner: folderData.folderOwner,
    });
});

var tokenExpire;

const getAccessToken = async () => {
  // const authInstance = window.gapi.auth2.getAuthInstance();
  // console.log(authInstance);
  // if (authInstance && authInstance.isSignedIn.get()) {
  //   return authInstance.currentUser.get().getAuthResponse().access_token;
  // } else {
  //   throw new Error("User is not signed in");
  // }
  
  const token = window.gapi.client.getToken();

  if (token !== null && tokenExpire !== undefined && Date.now() < tokenExpire.getTime()) {
    return token.access_token;
  } else {
    const doc = await firebase
    .firestore()
    .collection("accounts")
    .doc(folderOwner)
    .get();

    if (!doc.exists) {
      return null;
    }
    let refreshToken = doc.get("refreshToken");
    const params = new URLSearchParams({
      grant_type: "refresh_token",
      refreshToken,
      client_id: "134399078405-somaaqptj2muta7nks03t72n4rcfh7e9.apps.googleusercontent.com",
      client_secret: "WvpPaNpDft2ChfPY6kTuZN0O",
    });
    const response = await fetch("https://oauth2.googleapis.com/token?" + params,
      {
        method: "POST",
      },
    )

    if (!response.ok) {
      return null;
    }
    
    const data = await response.json(); 
    window.gapi.client.setToken({access_token: data.access_token});
    tokenExpire = new Date(Date.now() + data.expires_in * 1000);
    return data.access_token;
  }
};

export const validRefreshToken = async () => {
  const accessToken = await getAccessToken();
  
  if (accessToken === null) {
    return false;
  }
  return true;
};

export const findDriveFolder = async (folderName, folderID = "root") => {
  const accessToken = await getAccessToken();

  if(accessToken === null) return null;

  const searchQuery = `name='${folderName}' and mimeType='application/vnd.google-apps.folder' and '${folderID}' in parents`;

  const response = await fetch(
    `https://www.googleapis.com/drive/v3/files?q=${encodeURIComponent(
      searchQuery
    )}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const data = await response.json();

  if (data.files && data.files.length > 0) {
    const folderId = data.files[0].id;
    return folderId;
  } else {
    return null;
  }
};

export const createDriveFolder = async (folderName, folderID = "root") => {
  const accessToken = await getAccessToken();

  if (accessToken === null) return null;

  const folderMetadata = {
    name: folderName,
    mimeType: "application/vnd.google-apps.folder",
    parents: [folderID],
  };

  const createResponse = await fetch(
    "https://www.googleapis.com/drive/v3/files",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(folderMetadata),
    }
  );

  const createData = await createResponse.json();
  const folderId = createData.id;

  return folderId;
};

export const changeDriveFolder = async (folderId, newFolderName) => {
  const accessToken = await getAccessToken();

  const updateMetadata = {
    name: newFolderName,
  };

  const updateResponse = await fetch(
    `https://www.googleapis.com/drive/v3/files/${folderId}`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updateMetadata),
    }
  );

  if (!updateResponse.ok) {
    throw new Error("Failed to rename the folder");
  }

  const updatedData = await updateResponse.json();

  return updatedData.id;
};

export const uploadFileToFolder = async (fileBlob, fileName, folderId) => {
  const metadata = {
    name: fileName,
    mimeType: fileBlob.type,
    parents: [folderId],
  };

  const form = new FormData();
  form.append(
    "metadata",
    new Blob([JSON.stringify(metadata)], { type: "application/json" })
  );
  form.append("file", fileBlob);

  const accessToken = await getAccessToken();

  const response = await fetch(
    "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: form,
    }
  );

  const result = await response.json();
  if (DEVMODE) {
    console.log("File uploaded:", result);
  }
};

export const getFileFromFolder = async (fileName, folderId) => {
  const accessToken = await getAccessToken();

  if (accessToken === null) return null;

  const searchQuery = `name='${fileName}' and mimeType='image/png'`;
  const parentQuery = folderId ? ` and '${folderId}' in parents` : "";

  const response = await fetch(
    `https://www.googleapis.com/drive/v3/files?q=${searchQuery}${parentQuery}&fields=files(id,name)`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  console.log(response);
  const data = await response.json();

  if (data.files && data.files.length > 0) {
    return data.files[0].id; // Return the file ID
  } else {
    return null; // No file found
  }
};

export const downloadFileFromFolder = async (fileId) => {
  const accessToken = await getAccessToken();

  const downloadUrl = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;

  const fileResponse = await fetch(downloadUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!fileResponse.ok) {
    // console.log(`Failed to retrieve file: ${fileResponse.statusText}`);
    return null;
  }
  const blob = await fileResponse.blob();
  const url = URL.createObjectURL(blob);
  return url;
};

export const deleteFileFromFolder = async (fileId) => {
  const accessToken = await getAccessToken();

  const response = await fetch(
    `https://www.googleapis.com/drive/v3/files/${fileId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Failed to delete file: ${response.statusText}`);
  }
};

// export const shareFolder = async (fileId, userEmail) => {
//   const accessToken = await getAccessToken();
  
//   const permissionsMetadata = {
//     "type": "user",
//     "role": "writer",
//     "emailAddress": userEmail,
//   }

//   const response = await fetch(
//     `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
//     {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${accessToken}`,
//       },
//       body: JSON.stringify(permissionsMetadata),
//     }
//   );

//   if (!response.ok) {
//     console.log(response);
//     //throw new Error(`Failed to share folder with user: ${response.statusText}`);
//   }
// };

export const shareFolder = async (data) => {
  const accessToken = await getAccessToken();
  let sharedDriveUsers = data.sharedDriveUsers;
  let courseFolderID = data.courseFolderID;
  
  const permissions = await fetch(
    `https://www.googleapis.com/drive/v3/files/${courseFolderID}/permissions?fields=permissions(emailAddress,id,role)`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  if (!permissions.ok) {
    console.log(permissions);
    return;
  }
  const permissionList = await permissions.json();
  let currentSharedUsers = {};
  let removedUsers = [];
  let addedUsers = [];

  for (const user of permissionList.permissions) {
    if (user.role !== "writer") continue;

    currentSharedUsers[user.emailAddress] = user.id;

    if (!sharedDriveUsers.includes(user.emailAddress)) {
      removedUsers.push(user.id);
    }
  }

  for (const email of sharedDriveUsers) {

    if (!currentSharedUsers.hasOwnProperty(email)) {
      addedUsers.push(email);
    }
  }

  for (const id of removedUsers) {
    await fetch(
      `https://www.googleapis.com/drive/v3/files/${courseFolderID}/permissions/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }

  for (const email of addedUsers) {
    const permissionsMetadata = {
      "type": "user",
      "role": "writer",
      "emailAddress": email,
    }
    await fetch(
      `https://www.googleapis.com/drive/v3/files/${courseFolderID}/permissions`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(permissionsMetadata),
      }
    );
  }
    
  // const permissionsMetadata = {
  //   "type": "user",
  //   "role": "writer",
  //   "emailAddress": userEmail,
  // }

  // const response = await fetch(
  //   `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
  //   {
  //     method: "POST",
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`,
  //     },
  //     body: JSON.stringify(permissionsMetadata),
  //   }
  // );

  // if (!response.ok) {
  //   console.log(response);
  //   //throw new Error(`Failed to share folder with user: ${response.statusText}`);
  // }
};

export const sendResetPasswordEmail = (data) => {
  let email = data.email;
  const successMessage =
    "A password reset link will be sent if there is an account associated with this email: " +
    email;
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        resolve(successMessage);
      })
      .catch((err) => {
        // console.log(err.code, err.message);
        //alert(err);
        resolve(successMessage);
      });
  });
};

export const anonymousSignIn = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInAnonymously()
      .then((userCredential) => {
        let account = {};

        account["accountID"] = userCredential.user.uid;
        account["accountEmail"] = "";
        account["accountFirstName"] = "Anonymous";
        account["accountLastName"] = "";
        account["accountType"] = "student";

        resolve(account);
      })
      .catch((err) => {
        // console.log(err.code, err.message);
      });
  });
};

export const signIn = (data) => {
  let email = data.email;
  let password = data.password;

  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        firebase
          .app()
          .firestore()
          .collection("accounts")
          .doc(email)
          .get()
          .then((userDoc) => {
            let account = {};

            account["accountID"] = userDoc.id;
            account["accountEmail"] = userDoc.id;
            account["accountFirstName"] = userDoc.get("firstName");
            account["accountLastName"] = userDoc.get("lastName");
            // account["accountIdentifier"] = userDoc.get("identifier");
            account["accountType"] = userDoc.get("type");
            account["accountAdmin"] = userDoc.get("admin");

            resolve(account);
          });
      })
      .catch((err) => {
        switch (err.code) {
          case "auth/invalid-email":
            reject({ emailError: err.message });
            break;
          case "auth/user-not-found":
            reject({ emailError: err.message });
            break;
          case "auth/wrong-password":
            reject({ passwordError: err.message });
            break;
          default:
          // console.log(err.code, err.message);
        }
      });
  });
};

export const signUp = (data) => {
  let email = data.email;
  let password = data.password;
  // Auto-capitalize first letter of first/last name
  let firstName =
    data.firstName.charAt(0).toUpperCase() + data.firstName.slice(1);
  let lastName = data.lastName.charAt(0).toUpperCase() + data.lastName.slice(1);
  // let identifier = data.identifier;
  let type = data.type;

  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        firebase
          .firestore()
          .collection("courses")
          .get()
          .then((coursesSnapshot) => {
            let studentCourses = [];
            coursesSnapshot.forEach((courseSnapshot) => {
              let promise = courseSnapshot.ref
                .collection("students")
                .doc(email)
                .get()
                .then((courseStudentSnapshot) => {
                  if (courseStudentSnapshot.exists) {
                    return courseStudentSnapshot.ref
                      .update({
                        firstName: firstName,
                        lastName: lastName,
                        // identifier: identifier,
                      })
                      .then(() => {
                        return courseSnapshot.id;
                      });
                  }

                  return;
                });
              studentCourses.push(promise);
            });

            return Promise.all(studentCourses).then((result) => {
              return result.filter((element) => element !== undefined);
            });
          })
          .then((studentCourses) => {
            firebase.app().firestore().collection("accounts").doc(email).set({
              firstName: firstName,
              lastName: lastName,
              // identifier: identifier,
              studentCourses: studentCourses,
              type: type,
            });
          })
          .then(() => {
            firebase
              .app()
              .firestore()
              .collection("accounts")
              .doc(email)
              .get()
              .then((userDoc) => {
                let account = {};

                account["accountID"] = userDoc.id;
                account["accountEmail"] = userDoc.id;
                account["accountFirstName"] = userDoc.get("firstName");
                account["accountLastName"] = userDoc.get("lastName");
                // account["accountIdentifier"] = userDoc.get("identifier");
                account["accountType"] = userDoc.get("type");
                account["accountAdmin"] = userDoc.get("admin");

                resolve(account);
              });
          });
      })
      .catch((err) => {
        switch (err.code) {
          case "auth/email-already-in-use":
            reject({ emailError: err.message });
            break;
          case "auth/invalid-email":
            reject({ emailError: err.message });
            break;
          case "auth/weak-password":
            reject({ passwordError: err.message });
            break;
          default:
            // console.log(err.code, err.message);
            reject(err);
        }
      });
  });
};

export const signOut = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        resolve();
      })
      .catch((err) => {
        // console.log(err);
      });
  });
};

export const editAccount = (data) => {
  let accountEmail = data.accountEmail;
  let accountFirstName = data.accountFirstName;
  let accountLastName = data.accountLastName;
  // let accountIdentifier = data.accountIdentifier;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("accounts")
      .doc(accountEmail)
      .update({
        firstName: accountFirstName,
        lastName: accountLastName,
        // identifier: accountIdentifier,
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        // console.log(err);
      });
  });
};

export const searchAccount = (accountID) => {
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("accounts")
      .doc(accountID)
      .get()
      .then((doc) => {
        const dataWithID = { id: doc.id, ...doc.data() };
        resolve(dataWithID);
      });
  });
};

export const setAccount = (data) => {
  const { accountID, type } = data;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("accounts")
      .doc(accountID)
      .update({ type: type })
      .then(() => {
        resolve();
      });
  });
};
export const setLock = (data) => {
  const { accountID, courseID, locked, sessionID, pollID} = data;
  const vote = data.vote ?? "N/A";
  firebaseLogger({message: "setLock run for poll " + pollID + ", voted " + vote});
  const updateData = { locked: locked }; 
  if (sessionID) {
    updateData.lockedSessions = firebase.firestore.FieldValue.arrayUnion(sessionID);
  }
  return firebase
    .firestore()
    .collection("courses")
    .doc(courseID)
    .collection("students")
    .doc(accountID)
    .update(updateData);
};

/*
 Course-related functions
 */
const getCourse = (doc) => {
  let course = {};

  course["courseID"] = doc.id;
  course["courseName"] = doc.get("courseName");
  course["courseTerm"] = doc.get("courseTerm");
  course["courseCode"] = doc.get("courseCode");
  course["courseCategories"] = doc.get("courseCategories");
  course["courseInstructorID"] = doc.get("courseInstructorID");
  course["courseActivitySessionID"] = doc.get("courseActivitySessionID");
  course["courseActivityLastSessionID"] = doc.get("courseActivityLastSessionID");
  course["courseActivityPollID"] = doc.get("courseActivityPollID");
  course["courseActivityPollLive"] = doc.get("courseActivityPollLive");
  course["courseActivityPollDisplay"] = doc.get("courseActivityPollDisplay");
  course["courseInstructorID"] = doc.get("courseInstructorID");
  course["isActive"] = doc.get("isActive");
  course["iClickerEn"] = doc.get("iClickerEn");
  course["iClickerFreq"] = doc.get("iClickerFreq");
  course["anonVoteEn"] = doc.get("anonVoteEn");
  course["anonChooseCategories"] = doc.get("anonChooseCategories");
  // course["forcePID"] = doc.get("forcePID");
  course["restrictDomain"] = doc.get("restrictDomain");
  course["restrictDomainEmail"] = doc.get("restrictDomainEmail");
  course["restrictDomainOverride"] = doc.get("restrictDomainOverride");
  course["geofencing"] = doc.get("geofencing");
  course["geoDistance"] = doc.get("geoDistance");
  course["screenshotsEn"] = doc.get("screenshotsEn");
  course["screenshotDevice"] = doc.get("screenshotDevice");
  course["coInstructors"] = doc.get("coInstructors") ?? [];
  course["coInstructorEnableScreenshots"] = doc.get("coInstructorEnableScreenshots");
  course["tas"] = doc.get("tas") ?? [];
  course["taPrivileges"] = doc.get("taPrivileges") ?? [];
  course["studentPollHistory"] = doc.get("studentPollHistory");
  course["chooseCategories"] = doc.get("chooseCategories");
  course["docLink"] = doc.get("docLink");
  course["includedSessions"] = doc.get("includedSessions");
  course["googleDriveFolderID"] = doc.get("googleDriveFolderID");
  course["lockedPolls"] = doc.get("lockedPolls");
  course["courseCreated"] = doc.get("courseCreated");
  course["starred"] = doc.get("starred");
  course["markedForArchive"] = doc.get("markedForArchive");
  course["maxTAs"] = doc.get("maxTAs");
  course["notifyArchive"] = doc.get("notifyArchive");
  course["anonymousCourse"] = doc.get("anonymousCourse");
  // course["deviceOptions"] = doc.get("deviceOptions");

  return course;
};

export const listenCourseActivity = (data, callback) => {
  if (DEVMODE) {
    console.log("1 read + fetchCourseStudents, listenCourseActivity");
  }
  let courseID = data.courseID;

  return firebase
    .firestore()
    .collection("courses")
    .doc(courseID)
    .onSnapshot((docSnapshot) => {
      let course = getCourse(docSnapshot);
      fetchCourseStudents({ courseID: docSnapshot.id }).then((students) => {
        course["students"] = students;
        callback(course);
      });
    });
};



export const fetchCourses = (data) => {
  let accountID = data.accountID;
  let selRole = data.selRole;
  if (DEVMODE) {
    console.log(
      "1 read + # courses enrolled/own + fetchCourseStudents, fetchCourses"
    );
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("accounts")
      .doc(accountID)
      .get()
      .then((doc) => {
        let coursesRef;

        if (selRole === "" || selRole === undefined) {
          selRole = doc.get("type");
        }

        if (selRole === "instructor") {
          coursesRef = firebase
            .firestore()
            .collection("courses")
            .where("courseInstructorID", "==", accountID);
        } else if (selRole === "ta") {
            coursesRef = firebase
              .firestore()
              .collection("courses")
              .where("tas", "array-contains", accountID);
        } else if (selRole === "student") {
          let studentCourses = doc.get("studentCourses");
          if (studentCourses === undefined || studentCourses.length === 0) {
            resolve({});
          } else {
            coursesRef = firebase
              .firestore()
              .collection("courses")
              .where(
                firebase.firestore.FieldPath.documentId(),
                "in",
                studentCourses
              );
          }
        }

        if (coursesRef) {
          coursesRef
            .get()
            .then(async (query) => {
              let courses = {};
              let unsorted = [];
              let promises = [];

              query.forEach((doc) => {
                let promise = fetchCourseStudents({ courseID: doc.id }).then(
                  (students) => {
                    let course = getCourse(doc);
                    course["students"] = students;
                    unsorted.push([doc.id, course]);
                  }
                );
                promises.push(promise);
              });

              await Promise.all(promises);

              unsorted // Sort courses
                .sort((a, b) =>
                  a[1]["courseName"].localeCompare(b[1]["courseName"])
                )
                .map((course) => (courses[course[0]] = course[1]));

              resolve(courses);
            })
            .catch((err) => {
              if (DEVMODE) {
                console.log(err);
              }
            });
        } else {
          resolve([]);
        }
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const fetchCourse = (data) => {
  let courseID = data.courseID;
  if (DEVMODE) {
    console.log("1 read + fetchCourseStudents, fetchCourse");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .get()
      .then((courseSnapshot) => {
        fetchCourseStudents({ courseID: courseSnapshot.id }).then(
          (students) => {
            let course = getCourse(courseSnapshot);
            course["students"] = students;
            let courses = { [courseID]: course };
            resolve(courses);
          }
        );
      });
  });
};

export const getCoInstructorCourses = (data) => {
  let accountID = data.accountID;
  if (DEVMODE) {
    console.log("# of classes coinstructor for, coInstructorCourses");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .where("coInstructors", "array-contains", accountID)
      .get()
      .then((query) => {
        let courses = {};

        query.forEach((doc) => {
          let course = getCourse(doc);
          courses[doc.id] = course;
        });

        resolve(courses);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

// Geolocation Functions
export const getGeo = async (courseID) => {
  if (DEVMODE) {
    console.log("1 read, getGeo");
  }
  try {
    const doc = await firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .get();
    const geo = doc.data()["geofencing"];
    return !!geo;
  } catch (error) {
    console.error("Error getting geofencing data:", error);
    return false;
  }
};

export const getGeoDistance = async (courseID) => {
  if (DEVMODE) {
    console.log("1 read, getGeoDistance");
  }
  try {
    const doc = await firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .get();
    const geoDistance = doc.data()["geoDistance"];
    return geoDistance;
  } catch (error) {
    console.error("Error getting geofencing data:", error);
  }
};

export const searchCourses = (data) => {
  if (DEVMODE) {
    console.log("number of courses, searchCourses");
  }
  let courseCode = data.courseCode;
  let courseName = data.courseName;
  let anonSearch = data.anonSearch;

  courseCode = courseCode ? courseCode.toUpperCase() : courseCode;

  return new Promise((resolve, reject) => {
    if (!(courseCode || courseName)) {
      resolve({});
    } else {
      let coursesRef = firebase.firestore().collection("courses");
      if (courseCode) {
        coursesRef = coursesRef.where("courseCode", "==", courseCode);
      }
      if (courseName) {
        coursesRef = coursesRef
          .where("courseName", "==", courseName)
          .where("courseCode", "==", "");
      }
      if (anonSearch) {
        coursesRef = coursesRef.where("anonVoteEn", "==", true);
      }

      coursesRef
        .get()
        .then((query) => {
          let courses = {};

          query.forEach((doc) => {
            let course = getCourse(doc);
            let anonCourse = course.anonymousCourse ?? false;

            if (!anonCourse || anonSearch) {
              courses[doc.id] = course;
            }
          });

          resolve(courses);
        })
        .catch((err) => {
          if (DEVMODE) {
            console.log(err);
          }
        });
    }
  });
};

export const generateCourseCode = () => {
  let uniqueCode = false;
  if (DEVMODE) {
    console.log("number of courses, generateCourseCode");
  }
  return new Promise((resolve, reject) => {
    let newCode = "";

    while (!uniqueCode) {
      uniqueCode = true;
      let characters = "ABCDFGHJKLMNOPRSTUVWXYZ";
      for (let i = 0; i < 6; i++) {
        let charLocation = Math.floor(Math.random() * characters.length);
        newCode += characters.charAt(charLocation);
        characters =
          characters.substring(0, charLocation) +
          characters.substring(charLocation + 1);
      }

      firebase
        .firestore()
        .collection("courses")
        .get()
        .then((courses) => {
          courses
            .forEach((course) => {
              if (newCode === course.get("courseID")) {
                uniqueCode = false;
              }
            })
            .catch(() => {
              resolve("");
            });
        })
        .catch(() => {
          resolve("");
        });
    }

    resolve(newCode);
  });
};

export const createCourse = (data) => {
  let courseID = data.courseID;
  let courseName = data.courseName;
  let courseTerm = data.courseTerm;
  let courseCode = data.courseCode;
  let courseCategories = data.courseCategories;
  let modifiedCategories = data.modifiedCategories;
  let courseInstructorID = data.courseInstructorID;
  let isActive = data.isActive;
  let iClickerEn = data.iClickerEn;
  let iClickerFreq = data.iClickerFreq;
  let anonVoteEn = data.anonVoteEn;
  let anonChooseCategories = data.anonChooseCategories;
  // let forcePID = data.forcePID;
  let restrictDomain = data.restrictDomain;
  let restrictDomainEmail = data.restrictDomainEmail;
  let restrictDomainOverride = data.restrictDomainOverride;
  let geofencing = data.geofencing;
  let geoDistance = data.geoDistance;
  let screenshotsEn = data.screenshotsEn;
  let screenshotDevice = data.screenshotDevice;
  let coInstructors = data.coInstructors;
  let coInstructorEnableScreenshots = data.coInstructorEnableScreenshots;
  let studentPollHistory = data.studentPollHistory;
  let chooseCategories = data.chooseCategories;
  let docLink = data.docLink;
  // let tutors = data.tutors;
  let tas = data.tas;
  let taPrivileges = data.taPrivileges;
  let includedSessions = data.includedSessions;
  let googleDriveFolderID = data.googleDriveFolderID;
  let lockedPolls = data.lockedPolls;
  let anonymousCourse = data.anonymousCourse;
  let notifyArchive = data.notifyArchive;
  // let deviceOptions = data.deviceOptions;

  if (DEVMODE) {
    console.log("num students in course, createCourse, should be low ~0");
  }
  return new Promise((resolve, reject) => {
    if (courseID == "") {
      firebase
        .firestore()
        .collection("courses")
        .add({
          courseName: courseName,
          courseTerm: courseTerm,
          courseCode: courseCode,
          courseCategories: courseCategories,
          courseInstructorID: courseInstructorID,
          courseActivitySessionID: "",
          courseActivityPollID: "",
          courseActivityPollLive: false,
          courseActivityPollDisplay: false,
          students: [],
          isActive: isActive,
          iClickerEn: iClickerEn,
          iClickerFreq: iClickerFreq,
          anonVoteEn: anonVoteEn,
          anonChooseCategories: anonChooseCategories,
          // forcePID: forcePID,
          restrictDomain: restrictDomain,
          restrictDomainEmail: restrictDomainEmail,
          restrictDomainOverride: restrictDomainOverride,
          geofencing: geofencing,
          geoDistance: geoDistance,
          screenshotsEn: screenshotsEn,
          screenshotDevice: screenshotDevice,
          coInstructors: coInstructors,
          coInstructorEnableScreenshots: coInstructorEnableScreenshots,
          studentPollHistory: studentPollHistory,
          tas: tas,
          taPrivileges: taPrivileges,
          // tutors: tutors,
          includedSessions: includedSessions,
          chooseCategories: chooseCategories,
          docLink: docLink,
          googleDriveFolderID: googleDriveFolderID,
          lockedPolls:lockedPolls,
          anonymousCourse: anonymousCourse,
          // deviceOptions: deviceOptions,
          starred: false,
          markedForArchive: false,
          maxTAs: 20,
          courseCreated: Date.now(),
          notifyArchive: notifyArchive,
        })
        .then((course) => {
          resolve(course.id);
        })
        .catch((err) => {
          if (DEVMODE) {
            console.log(err);
          }
        });
    } else {
      firebase
        .firestore()
        .collection("courses")
        .doc(courseID)
        .update({
          courseName: courseName,
          courseTerm: courseTerm,
          courseCode: courseCode,
          courseCategories: courseCategories,
          courseActivitySessionID: "",
          courseActivityPollID: "",
          courseActivityPollLive: false,
          courseActivityPollDisplay: false,
          isActive: isActive,
          iClickerEn: iClickerEn,
          iClickerFreq: iClickerFreq,
          anonVoteEn: anonVoteEn,
          anonChooseCategories: anonChooseCategories,
          // forcePID: forcePID,
          restrictDomain: restrictDomain,
          restrictDomainEmail: restrictDomainEmail,
          restrictDomainOverride: restrictDomainOverride,
          geofencing: geofencing,
          geoDistance: geoDistance,
          screenshotsEn: screenshotsEn,
          screenshotDevice: screenshotDevice,
          coInstructors: coInstructors,
          coInstructorEnableScreenshots: coInstructorEnableScreenshots,
          studentPollHistory: studentPollHistory,
          // tutors: tutors,
          tas: tas,
          taPrivileges: taPrivileges,
          includedSessions: includedSessions,
          chooseCategories: chooseCategories,
          docLink: docLink,
          googleDriveFolderID: googleDriveFolderID,
          lockedPolls:lockedPolls,
          anonymousCourse: anonymousCourse,
          notifyArchive: notifyArchive,
          // deviceOptions: deviceOptions,
        })
        .then(() => {
          return firebase
            .firestore()
            .collection("courses")
            .doc(courseID)
            .collection("students")
            .get();
        })
        .then((studentsSnapshot) => {
          return new Promise((resolve, reject) => {
            let promises = [];
            studentsSnapshot.forEach((studentSnapshot) => {
              let promise = studentSnapshot.ref.update({
                studentCategories: Object.fromEntries(
                  Object.entries(
                    studentSnapshot.get("studentCategories")
                  ).reduce((newEntries, [name, option]) => {
                    if (!modifiedCategories.includes(name)) {
                      newEntries.push([name, option]);
                    }
                    return newEntries;
                  }, [])
                ),
              });
              promises.push(promise);
            });

            Promise.all(promises).then(() => {
              resolve();
            });
          });
        })
        .then(() => {
          resolve(courseID);
        })
        .catch((err) => {
          if (DEVMODE) {
            console.log(err);
          }
        });
    }
  });
};

export const fetchCourseStudents = (data) => {
  let courseID = data.courseID;
  if (DEVMODE) {
    console.log("# of students in course  fetchCourseStudents");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .collection("students")
      .orderBy("lastName")
      .get()
      .then((query) => {
        let students = {};
        query.forEach((doc) => {
          let student = {};
          student["firstName"] = doc.get("firstName");
          student["lastName"] = doc.get("lastName");
          // student["identifier"] = doc.get("identifier");
          student["iClicker"] = doc.get("iClicker");
          student["locked"] = doc.get("locked");
          student["studentCategories"] = doc.get("studentCategories");
          student["archived"] = doc.get("archived");
          students[doc.id] = student;
        });

        resolve(students);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

// When the categories of a student is changed, change all previous polls to update the correct category
const changePreviousPollCategories = async (data) => {
  // studentCategories is an array
  let { courseID, studentID, studentCategories } = data;

  try {
    let sessionsSnapshot = await firebase
      .firestore()
      .collection("sessions")
      .where("sessionCourseID", "==", courseID)
      .orderBy("sessionStartTime")
      .get();

    let promises1 = sessionsSnapshot.docs.map(async (sessionSnapshot) => {
      let pollsSnapshot = await firebase
        .firestore()
        .collection("polls")
        .where("pollSessionID", "==", sessionSnapshot.id)
        .get();

      let pollPromises = pollsSnapshot.docs.map(async (pollDoc) => {
        const studentPoll = firebase
          .firestore()
          .collection("polls")
          .doc(pollDoc.id)
          .collection("students")
          .doc(studentID);

        if ((await studentPoll.get()).exists) {
          await studentPoll.update({ studentCategories: studentCategories });
        } 
      });
      await Promise.all(pollPromises);
    });

    await Promise.all(promises1);
  } catch (err) {
    if (DEVMODE) console.log("Failed to update for session:", err);
  }
};

export const setStudentCategories = async (data) => {
  let courseID = data.courseID;
  let studentID = data.studentID;
  let dataCategories = data.studentCategories;

  try {
    let doc = await firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .collection("students")
      .doc(studentID)
      .get();

    if (!doc.exists) {
      return;
    }

    // If there is a change in student categories then update
    const docCategories = doc.data().studentCategories;
    const keys = Object.keys(dataCategories);
    for (let key of keys) {
      const value1 = dataCategories[key];
      const value2 = docCategories[key];
      if (value1 != value2) {
        await firebase
          .firestore()
          .collection("courses")
          .doc(courseID)
          .collection("students")
          .doc(studentID)
          .update({ studentCategories: dataCategories });
        changePreviousPollCategories(data);
        break;
      }
    }
  } catch (err) {
    if (DEVMODE) console.error("Error fetching document:", err);
  }
};

export const setCourseStudents = (data) => {
  if (DEVMODE) {
    console.log(
      "large number of reads, if runs too much, check, setCourseStudents"
    );
  }
  let courseID = data.courseID;
  let students = data.students;
  let deletedStudents = data.initialStudents.filter(
    (student) => students[student] === undefined
  );

  return new Promise((resolve, reject) => {
    let promises = [];

    for (let studentID of deletedStudents) {
      let promiseDeleteFromCourse = firebase
        .firestore()
        .collection("courses")
        .doc(courseID)
        .collection("students")
        .doc(studentID)
        .delete();
      promises.push(promiseDeleteFromCourse);
      let promiseDeleteFromStudent = firebase
        .firestore()
        .collection("accounts")
        .doc(studentID)
        .get()
        .then((studentSnapshot) => {
          if (studentSnapshot.exists) {
            firebase
              .firestore()
              .collection("accounts")
              .doc(studentID)
              .update({
                studentCourses:
                  firebase.firestore.FieldValue.arrayRemove(courseID),
              });
          }
        });
      promises.push(promiseDeleteFromStudent);
    }

    for (let studentID in students) {
      let courseStudentRef = firebase
        .firestore()
        .collection("courses")
        .doc(courseID)
        .collection("students")
        .doc(studentID);
      let iClicker;
      let locked;
      let studentCategories;
      let promise = courseStudentRef
        .get()
        .then((courseStudentDoc) => {
          if (!courseStudentDoc.exists) {
            return firebase
              .firestore()
              .collection("accounts")
              .doc(studentID)
              .update({
                studentCourses: firebase.firestore.FieldValue.arrayUnion(courseID),
                anonCourses: firebase.firestore.FieldValue.arrayRemove(courseID),
              });
          } else {
            return;
          }
        })
        .then(async () => {
          iClicker = students[studentID]["iClicker"];
          locked = students[studentID]["locked"]
          studentCategories = students[studentID]["studentCategories"];
          data = {
            courseID: courseID,
            studentID: studentID,
            locked: locked,
            studentCategories: studentCategories,
          };
          await setStudentCategories(data);
          return courseStudentRef.set({
            firstName:
              students[studentID]["firstName"] === undefined
                ? ""
                : students[studentID]["firstName"],
            lastName:
              students[studentID]["lastName"] === undefined
                ? ""
                : students[studentID]["lastName"],
            // identifier:
            //   students[studentID]["identifier"] === undefined
            //     ? ""
            //     : students[studentID]["identifier"],
            iClicker:
              students[studentID]["iClicker"] === undefined
                ? ""
                : students[studentID]["iClicker"],
            studentCategories: students[studentID]["studentCategories"],
            locked : students[studentID]["locked"] === undefined ? "0" : students[studentID]["locked"],
          });
        })
        .then(() => {
          return new Promise(async (resolve, reject) => {
            if (!iClicker) {
              resolve();
              return;
            }
            let unlinkedVotesSnapshot = await firebase
              .firestore()
              .collection("courses")
              .doc(courseID)
              .collection("unlinkedVotes")
              .doc(iClicker)
              .get();
            if (!unlinkedVotesSnapshot.exists) {
              resolve();
              return;
            }
            let polls = unlinkedVotesSnapshot.get("polls");
            if (!polls.length) {
              resolve();
              return;
            }
            for (const pollID of polls) {
              let unlinkedVoteSnapshot = await firebase
                .firestore()
                .collection("polls")
                .doc(pollID)
                .collection("students")
                .doc(iClicker)
                .get();
              await firebase
                .firestore()
                .collection("polls")
                .doc(pollID)
                .collection("student")
                .doc(studentID)
                .set({
                  iClicker: iClicker,
                  studentVote: unlinkedVoteSnapshot.get("studentVote"),
                  studentCategories: studentCategories,
                });
              unlinkedVoteSnapshot.ref.delete();
            }
            unlinkedVotesSnapshot.ref.delete();
            resolve();
          });
        });

      promises.push(promise);
    }

    Promise.all(promises)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

/*
 * DATA FORMAT:
 *
 * data = [
 *   {
 *     categories: [
 *       'category1',
 *        ...
 *     ],
 *     sessions: [
 *       #, // Number of polls for session 1
 *        ...
 *     ]
 *   },
 *   {
 *     studentFirstName: 'studentFirstName',
 *     studentLastName: 'studentLastName',
 *     studentID: 'studentID',
 *     identifier: 'identifier',
 *     iClicker: 'iClicker',
 *     studentCategories: [
 *       'optionA' // Option chosen for category1
 *        ...
 *     ],
 *     studentVotes: [
 *       'A',
 *        ...
 *     ],
 *   },
 *    ...
 * ]
 */
export const convertUnixToDate = (unixTime) => {
  //remove years
  let day = new Date(unixTime);
  let months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return (
    months[day.getMonth()] + " " + day.getDate() + ", " + day.getFullYear()
  );
};
//you should just use the get votes, and steal all the info at this point.
export const getSessionInfo = async (courseID) => {
  let data = [
    {
      sessions: [],
      dates: [],
      polls: [],
    },
  ];
  let sessionsSnapshot = await firebase
    .firestore()
    .collection("sessions")
    .where("sessionCourseID", "==", courseID)
    .orderBy("sessionStartTime")
    .get();
  let promises1 = sessionsSnapshot.docs.map(async (sessionSnapshot) => {
    let pollsSnapshot = await firebase
      .firestore()
      .collection("polls")
      .where("pollSessionID", "==", sessionSnapshot.id)
      .orderBy("pollStartTime")
      .get();

    let numPolls = 0;
    let pollVotes = [];
    let info = sessionSnapshot.data();
    let promises2 = pollsSnapshot.docs.map(async (pollSnapshot) => {
      let answersSnapshot = await firebase
        .firestore()
        .collection("polls")
        .doc(pollSnapshot.id)
        .collection("students")
        .get();
      pollVotes.push(answersSnapshot.docs.length);
      numPolls++;
    });

    await Promise.all(promises2);
    if (numPolls != 0) {
      data[0].sessions.push(numPolls);
      data[0].dates.push(convertUnixToDate(info.sessionStartTime));
      data[0].polls.push(pollVotes);
    }
  });
  await Promise.all(promises1);
  return data;
};
export const getCourseVotes = async (courseID) => {
  if (DEVMODE) {
    console.log(
      "1 read + num of students, + num of sessions, + number of polls + 2* num of student per poll, getCourseVotes"
    );
  }
  try {
    let data = [
      {
        categories: [],
        sessions: [],
        answers: [],
      },
    ];

    // Populate data with categories
    let courseRef = firebase.firestore().collection("courses").doc(courseID);
    let iClickerEn;
    await courseRef.get().then((courseSnapshot) => {
      data[0].categories = Object.keys(courseSnapshot.get("courseCategories"));
      iClickerEn = courseSnapshot.get("iClickerEn");
    });

    // Populate data with students
    let studentsSnapshot = await courseRef.collection("students").get();
    let promises = [];
    for (let courseStudentSnapshot of studentsSnapshot.docs) {
      let studentCategories = [];
      data[0].categories.forEach((category) => {
        studentCategories.push(
          courseStudentSnapshot.get("studentCategories")[category]
        );
      });

      data.push(
        Object.assign(
          {},
          {
            studentFirstName: courseStudentSnapshot.get("firstName"),
            studentLastName: courseStudentSnapshot.get("lastName"),
            studentID: courseStudentSnapshot.id,
            // identifier: courseStudentSnapshot.get("identifier"), // TODO: If you change identifiers to be course-exclusive, change this to courseStudentSnapshot
            studentCategories: studentCategories,
            studentVotes: [],
          },
          iClickerEn ? { iClicker: courseStudentSnapshot.get("iClicker") } : {}
        )
      );

      promises.push(Promise.resolve());
    }
    await Promise.all(promises);
    let anonA = { studentID: "A", studentVotes: [] };
    let anonB = { studentID: "B", studentVotes: [] };
    let anonC = { studentID: "C", studentVotes: [] };
    let anonD = { studentID: "D", studentVotes: [] };
    let anonE = { studentID: "E", studentVotes: [] };
    let anonIndex = 0;
    // Populate data with votes
    let sessionsSnapshot = await firebase
      .firestore()
      .collection("sessions")
      .where("sessionCourseID", "==", courseID)
      .orderBy("sessionStartTime")
      .get();
    let promises1 = sessionsSnapshot.docs.map(async (sessionSnapshot) => {
      let pollsSnapshot = await firebase
        .firestore()
        .collection("polls")
        .where("pollSessionID", "==", sessionSnapshot.id)
        .orderBy("pollStartTime")
        .get();

      let numPolls = 0;
      let ans = [];
      let promises2 = pollsSnapshot.docs.map(async (pollSnapshot) => {
        numPolls++;
        data[0].answers.push(pollSnapshot.data().answer);
        let pollStudentsSnapshot = await pollSnapshot.ref
          .collection("students")
          .get();
        anonA.studentVotes.push(0);
        anonB.studentVotes.push(0);
        anonC.studentVotes.push(0);
        anonD.studentVotes.push(0);
        anonE.studentVotes.push(0);
        let students = [];
        pollStudentsSnapshot.forEach((studentSnapshot) => {
          let studentIndex = data.findIndex(
            (obj) => obj.studentID === studentSnapshot.id
          );
          if (studentIndex !== -1) {
            students.push(studentSnapshot.id);
            data[studentIndex].studentVotes.push(
              studentSnapshot.get("studentVote")
            );
          } else {
            let vote = studentSnapshot.get("studentVote");
            if (vote.includes("A")) {
              anonA.studentVotes[anonIndex] = anonA.studentVotes[anonIndex] + 1;
            } else if (vote.includes("B")) {
              anonB.studentVotes[anonIndex] = anonB.studentVotes[anonIndex] + 1;
            } else if (vote.includes("C")) {
              anonC.studentVotes[anonIndex] = anonC.studentVotes[anonIndex] + 1;
            } else if (vote.includes("D")) {
              anonD.studentVotes[anonIndex] = anonD.studentVotes[anonIndex] + 1;
            } else if (vote.includes("E")) {
              anonE.studentVotes[anonIndex] = anonE.studentVotes[anonIndex] + 1;
            }
          }
        });
        anonIndex++;
        for (let i = 1; i < data.length; i++) {
          if (students.indexOf(data[i].studentID) === -1) {
            data[i].studentVotes.push(undefined);
          }
        }
      });

      await Promise.all(promises2);
      data[0].sessions.push(numPolls);
    });
    await Promise.all(promises1);
    data.push(anonA);
    data.push(anonB);
    data.push(anonC);
    data.push(anonD);
    data.push(anonE);
    return data;
  } catch (err) {
    if (DEVMODE) {
      console.log(err);
    }
    return undefined;
  }
};
export const getStudentVotes = async (courseID, studentID) => {
  if (DEVMODE) {
    console.log(
      "2 reads + # of sessions, + # of polls + 2*# of times student voted in polls, getStudentVotes"
    );
  }
  try {
    let data = [
      {
        categories: [],
        sessions: [],
        dates: [],
      },
    ];

    // Populate data with categories
    let courseRef = firebase.firestore().collection("courses").doc(courseID);
    let iClickerEn;
    await courseRef.get().then((courseSnapshot) => {
      data[0].categories = Object.keys(courseSnapshot.get("courseCategories"));
      iClickerEn = courseSnapshot.get("iClickerEn");
    });

    // Populate data with students
    let studentSnapshot = await courseRef
      .collection("students")
      .doc(studentID)
      .get();
    let promises = [];
    let studentCategories = [];
    data[0].categories.forEach((category) => {
      studentCategories.push(
        studentSnapshot.get("studentCategories")[category]
      );
    });

    data.push(
      Object.assign(
        {},
        {
          studentFirstName: studentSnapshot.get("firstName"),
          studentLastName: studentSnapshot.get("lastName"),
          studentID: studentSnapshot.id,
          // identifier: studentSnapshot.get("identifier"), // TODO: If you change identifiers to be course-exclusive, change this to courseStudentSnapshot
          studentCategories: studentCategories,
          studentVotes: [],
        },
        iClickerEn ? { iClicker: studentSnapshot.get("iClicker") } : {}
      )
    );

    promises.push(Promise.resolve());
    await Promise.all(promises);

    // Populate data with votes
    let sessionsSnapshot = await firebase
      .firestore()
      .collection("sessions")
      .where("sessionCourseID", "==", courseID)
      .orderBy("sessionStartTime")
      .get();
    let promises1 = sessionsSnapshot.docs.map(async (sessionSnapshot) => {
      let info = sessionSnapshot.data();
      let pollsSnapshot = await firebase
        .firestore()
        .collection("polls")
        .where("pollSessionID", "==", sessionSnapshot.id)
        .orderBy("pollStartTime")
        .get();

      let numPolls = 0;
      let promises2 = pollsSnapshot.docs.map(async (pollSnapshot) => {
        numPolls++;
        let pollStudentSnapshot = await pollSnapshot.ref
          .collection("students")
          .doc(studentID)
          .get();

        let students = [];

        let studentIndex = data.findIndex(
          (obj) => obj.studentID === pollStudentSnapshot.id
        );
        if (studentIndex !== -1) {
          students.push(pollStudentSnapshot.id);
          data[studentIndex].studentVotes.push(
            pollStudentSnapshot.get("studentVote")
          );
        }

        for (let i = 1; i < data.length; i++) {
          if (students.indexOf(data[i].studentID) === -1) {
            data[i].studentVotes.push(undefined);
          }
        }
      });

      await Promise.all(promises2);
      data[0].sessions.push(numPolls);
      data[0].dates.push(convertUnixToDate(info.sessionStartTime));
    });
    await Promise.all(promises1);
    console.log(data);
    return data;
  } catch (err) {
    if (DEVMODE) {
      console.log(err);
    }
    return undefined;
  }
};

/*
 Session-related functions
 */
export const fetchSessions = (data) => {
  let courseID = data.courseID;
  if (DEVMODE) {
    console.log("# of sessions in course, fetchSessions");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("sessions")
      .where("sessionCourseID", "==", courseID)
      .orderBy("sessionStartTime")
      .get()
      .then((query) => {
        let sessions = {};

        let index = 0;
        query.forEach((doc) => {
          let session = {};
          session["sessionID"] = doc.id;
          session["sessionIndex"] = ++index;
          session["sessionStartTime"] = doc.get("sessionStartTime");
          session["sessionCourseID"] = doc.get("sessionCourseID");
          session["sessionOverrideLive"] = doc.get("sessionOverrideLive");
          sessions[doc.id] = session;
        });

        resolve(sessions);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const listenSessionActivity = (data, callback) => {
  let sessionID = data.sessionID;
  let studentUnsubs = [];

  const fetchStudents = async (sessionDoc) => {
    const studentsCollectionRef = firebase
      .firestore()
      .collection("sessions")
      .doc(sessionID)
      .collection("students");

    try {
      const studentsSnapshot = await studentsCollectionRef.get();
      if (studentsSnapshot.empty) {
        callback({
          ...sessionDoc.data(),
          sessionID: sessionID,
          students: [],
        });
        return;
      }

      const studentsData = [];

      // Clear previous listeners
      studentUnsubs.forEach((unsub) => unsub());
      studentUnsubs = [];

      studentsSnapshot.forEach((doc) => {
        const unsubStudent = studentsCollectionRef
          .doc(doc.id)
          .onSnapshot((studentDocSnapshot) => {
            const studentIndex = studentsData.findIndex(
              (student) => student.id === doc.id
            );
            if (studentIndex > -1) {
              studentsData[studentIndex] = {
                id: doc.id,
                ...studentDocSnapshot.data(),
              };
            } else {
              studentsData.push({
                id: doc.id,
                ...studentDocSnapshot.data(),
              });
            }

            const sessionData = {
              ...sessionDoc.data(),
              sessionID: sessionID,
              students: studentsData,
            };
            callback(sessionData);
          });
        studentUnsubs.push(unsubStudent);
      });
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const sessionUnsub = firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .onSnapshot(async (docSnapshot) => {
      await fetchStudents(docSnapshot);
    });
  return () => {
    sessionUnsub();
    studentUnsubs.forEach((unsub) => unsub());
  };
};

export const createSession = (data) => {
  let sessionStartTime = data.sessionStartTime;
  let sessionCourseID = data.sessionCourseID;
  let instructorLatitude = data.instructorLatitude || 0;
  let instructorLongitude = data.instructorLongitude || 0;
  let geoInactive = data.geoInactive || false;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("sessions")
      .add({
        sessionStartTime: sessionStartTime,
        sessionCourseID: sessionCourseID,
        instructorLatitude: instructorLatitude,
        instructorLongitude: instructorLongitude,
        sessionOverrideLive: false,
        geoInactive: geoInactive,
      })
      .then((session) => {
        firebase
          .firestore()
          .collection("courses")
          .doc(sessionCourseID)
          .update({ courseActivityLastSessionID: session.id });
        resolve(session.id);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const getInstructorLocation = async (sessionCourseID) => {
  if (DEVMODE) {
    console.log("1 call getinstrucotrlocation");
  }
  try {
    const querySnapshot = await firebase
      .firestore()
      .collection("sessions")
      .where("sessionCourseID", "==", sessionCourseID)
      .orderBy("sessionStartTime", "desc")
      .limit(1)
      .get();

    if (!querySnapshot.empty) {
      const sessionSnapshot = querySnapshot.docs[0];
      return {
        instructorLatitude: sessionSnapshot.get("instructorLatitude"),
        instructorLongitude: sessionSnapshot.get("instructorLongitude"),
      };
    } else {
      alert("No sessions found for this course");
    }
  } catch (err) {
    alert(err);
  }
};

export const activateSession = (data) => {
  let sessionID = data.sessionID;
  let totStudents = data.totStudents;
  if (DEVMODE) {
    console.log("1 read, activate session");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("sessions")
      .doc(sessionID)
      .get()
      .then((session) => {
        return firebase
          .firestore()
          .collection("courses")
          .doc(session.get("sessionCourseID"))
          .update({
            courseActivityLastSessionID: session.id,
            courseActivitySessionID: session.id,
            courseActivityPollID: "",
            courseActivityPollLive: false,
            courseActivityPollDisplay: false,
            totStudents: totStudents,
          });
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const resumeSession = (data) => {
  let courseID = data.courseID;
  let instructorLatitude = data.instructorLatitude || 0;
  let instructorLongitude = data.instructorLongitude || 0;
  let geoInactive = data.geoInactive || false;
  let sessionID;

  if (DEVMODE) {
    console.log("1 read, resumeSession");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .get()
      .then((courseSnapshot) => {
        sessionID = courseSnapshot.get("courseActivityLastSessionID");
        return courseSnapshot.ref.update({
          courseActivitySessionID: sessionID,
          courseActivityPollID: "",
          courseActivityPollLive: false,
          courseActivityPollDisplay: false,
        });
      })
      .then(() => {
        if (
          instructorLatitude == 0 &&
          instructorLongitude == 0 &&
          !geoInactive
        ) {
          return;
        }
        firebase.firestore().collection("sessions").doc(sessionID).update({
          instructorLatitude: instructorLatitude,
          instructorLongitude: instructorLongitude,
          geoInactive: geoInactive,
        });
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const deactivateSession = (data) => {
  if (DEVMODE) {
    console.log("1 read, deactivateSession");
  }
  let courseID = data.courseID;
  let stopCompletely = data.stopCompletely || false;

  let sessionSettings = {
    courseActivitySessionID: "",
    courseActivityPollID: "",
    courseActivityPollLive: false,
    courseActivityPollDisplay: false,
  };
  if (stopCompletely) {
    sessionSettings.courseActivityLastSessionID = false;
  }

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .update(sessionSettings)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const deleteSession = (data) => {
  let sessionID = data.sessionID;
  if (DEVMODE) {
    console.log("1 read, deleteSession");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("sessions")
      .doc(sessionID)
      .get()
      .then((sessionSnapshot) => {
        // Remove all polls
        return firebase
          .firestore()
          .collection("polls")
          .where("pollSessionID", "==", sessionID)
          .get()
          .then((pollsSnapshot) => {
            let promises = [];
            pollsSnapshot.forEach((pollSnapshot) => {
              let promise = pollSnapshot.ref
                .collection("students")
                .get()
                .then((studentsSnapshot) => {
                  if (!studentsSnapshot.empty) {
                    studentsSnapshot.forEach((studentSnapshot) => {
                      studentSnapshot.ref.delete();
                    });
                  }
                })
                .then(() => {
                  pollSnapshot.ref.delete();
                })
                .catch((err) => {
                  if (DEVMODE) {
                    console.log(err);
                  }
                });

              promises.push(promise);
            });

            return Promise.all(promises);
          })
          .then(() => {
            return firebase
              .firestore()
              .collection("courses")
              .doc(sessionSnapshot.get("sessionCourseID"))
              .get();
          })
          .then((courseSnapshot) => {

            if (courseSnapshot.get("courseActivitySessionID") == sessionID) {
              return deactivateSession({
                courseID: courseSnapshot.get("courseActivitySessionID"),
                stopCompletely: true,
              });
            }
          })
          .then(() => {
            return sessionSnapshot.ref.delete();
          })
          .then(() => {
            const data = { courseID: sessionSnapshot.get("sessionCourseID") };
            fetchSessions(data).then((sessions) => {
              let maxIndex = 0;
              let sessionWithMaxIndex;
              Object.values(sessions).forEach((session) => {
                if (session.sessionIndex > maxIndex) {
                  maxIndex = session.sessionIndex;
                  sessionWithMaxIndex = session;
                }
              });
              if (sessionWithMaxIndex) {
                return firebase
                  .firestore()
                  .collection("courses")
                  .doc(sessionSnapshot.get("sessionCourseID"))
                  .update({
                    courseActivityLastSessionID: sessionWithMaxIndex.sessionID,
                  });
              } else {
                return firebase
                  .firestore()
                  .collection("courses")
                  .doc(sessionSnapshot.get("sessionCourseID"))
                  .update({ courseActivityLastSessionID: "" });
              }
            });
          });
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

/*export const mergeSession = (data) => {
  let courseID = data.courseID;
  let sessionID = data.sessionID;
  let seshNum = data.sessionNum;
  let prevSesh;
  fetchSessions({ courseID: courseID }).then((data) => {
    for (let datum of Object.keys(data)) {
      if (data[datum].sessionIndex == seshNum - 1) {
        prevSesh = data[datum].sessionID;
      }
    }
    firebase
      .firestore()
      .collection("polls")
      .where("pollSessionID", "==", sessionID)
      .get()
      .then((polls) => {
        if (DEVMODE) {
          console.log(polls);
        }
        const batch = firebase.firestore().batch();
        polls.forEach((doc) => {
          batch.update(doc.ref, { pollSessionID: prevSesh });
        });
        batch.commit();
      }).catch((err)=>{
        if (DEVMODE) {
          console.log(err);
        }
      })
      .then(() => {
        if (DEVMODE) {
          console.log("Merged sessions");
        }
        deleteSession({ sessionID: sessionID });
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });

};
*/
export const mergeSession = (data) => {
  let courseID = data.courseID;
  let sessionID = data.sessionID;
  let seshNum = data.sessionNum;

  return new Promise((resolve, reject) => {
    let prevSesh;

    fetchSessions({ courseID: courseID })
      .then((sessions) => {
        // Find the previous session ID
        for (let datum of Object.keys(sessions)) {
          if (sessions[datum].sessionIndex == seshNum - 1) {
            prevSesh = sessions[datum].sessionID;
          }
        }

        // Get polls and update their session IDs
        return firebase
          .firestore()
          .collection("polls")
          .where("pollSessionID", "==", sessionID)
          .get();
      })
      .then((polls) => {
        if (DEVMODE) {
          console.log(polls);
        }
        const batch = firebase.firestore().batch();
        polls.forEach((doc) => {
          batch.update(doc.ref, { pollSessionID: prevSesh });
        });

        // Commit the batch
        return batch.commit();
      }).catch((err)=>{
        if (DEVMODE) {
          console.log("Failed to move polls");
        }
        reject(err);
      })
      .then(() => {
        if (DEVMODE) {
          console.log("Merged sessions");
        }
        // Delete the current session
        return deleteSession({ sessionID: sessionID });
      })
      .then(() => {
        resolve("Merged");
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
        reject(err);
      });
  });
};
export const splitSession = (data) => {
  let sessionID = data.sessionID;
  let splitID = data.splitID;
  let pollData = data.pollData;
  let movePolls = [];
  let addStuff = 0;
  for (let i = 0; i < pollData.length; i++) {
    if (addStuff == 1) {
      movePolls.push(pollData[i]);
    }
    if (pollData[i] == splitID) {
      addStuff = 1;
    }
  }
  firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .get()
    .then((sesh) => {
      let newSesh = sesh.data();
      newSesh.sessionStartTime = newSesh.sessionStartTime + 1;
      createSession(newSesh)
        .then((splitSesh) => {
          console.log(splitSesh);
          firebase
            .firestore()
            .collection("polls")
            .where("pollSessionID", "==", sessionID)
            .get()
            .then((polls) => {
              const batch = firebase.firestore().batch();
              polls.docs.forEach((poll) => {
                if (movePolls.includes(poll.id)) {
                  batch.update(poll.ref, { pollSessionID: splitSesh });
                }
              });
              batch.commit();
            })
            .catch((err) => {
              if (DEVMODE) {
                console.log(err);
              }
            });
        })
        .catch((err) => {
          if (DEVMODE) {
            console.log(err);
          }
        });
    })
    .catch((err) => {
      if (DEVMODE) {
        console.log(err);
      }
    });
};
export const setOverrideLive = (data) => {
  let sessionID = data.sessionID;
  let status = data.status;

  return firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .update({ sessionOverrideLive: status });
};

export const setStudentOverrideRequest = (data) => {
  let sessionID = data.sessionID;
  let studentID = data.studentID;
  let overrideRequest = data.overrideRequest;

  return firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .collection("students")
    .doc(studentID)
    .update({ overrideRequest: overrideRequest });
};

export const setStudentOverriden = async (data) => {
  let sessionID = data.sessionID;
  let studentID = data.studentID;

  firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .collection("students")
    .doc(studentID)
    .update({ overrideRequest: false, overriden: true });

  try {
    const pollsSnapshot = await firebase
      .firestore()
      .collection("polls")
      .where("pollSessionID", "==", sessionID)
      .get();
    pollsSnapshot.forEach(async (doc) => {
      const studentSnapshot = await doc.ref
        .collection("students")
        .doc(studentID)
        .get();
      if (studentSnapshot.data().studentVote.includes("G")) {
        let newVote = "";
        {
          if (doc.data().pollAnonymous) {
            newVote = studentSnapshot.data().studentVote.includes("X")
              ? studentSnapshot.data().studentVote.replace("G", "")
              : studentSnapshot.data().studentVote.replace("G", "X");
          } else {
            newVote = studentSnapshot.data().studentVote.replace("G", "");
          }
        }
        doc.ref
          .collection("students")
          .doc(studentID)
          .update({ studentVote: newVote });
      }
    });
  } catch (err) {
    if (DEVMODE) {
      console.log(err);
    }
  }
};
export const setStudentUnlocked = async (data) => {
  let courseID = data.courseID;
  let studentID = data.accountID;
  console.log(studentID);
  let sessionID = data.sessionID;

  try {
    /*const querySnapshot = await firebase.firestore()
      .collection('courses')  // Parent collection
      .doc(courseID)          // Specific course document
      .collection('students') // Subcollection of students
      .doc(studentID)         // Specific student document     
      .get();

    const docData = querySnapshot.data();
    const yourArray = docData.lockedSessions;
    console.log(yourArray)*/
    //for (const doc of yourArray) {
      try {
        const pollsSnapshot = await firebase
          .firestore()
          .collection("polls")
          .where("pollSessionID", "==", sessionID)
          .get();
        for (const pollDoc of pollsSnapshot.docs) {
          const studentSnapshot = await pollDoc.ref
            .collection("students")
            .doc(studentID)
            .get();
          if (studentSnapshot.data().studentVote.includes("L")) {
            let newVote = "";
            if (pollDoc.data().pollAnonymous) {
              newVote = studentSnapshot.data().studentVote.includes("X")
                ? studentSnapshot.data().studentVote.replace("L", "")
                : studentSnapshot.data().studentVote.replace("L", "X");
            } else {
              newVote = studentSnapshot.data().studentVote.replace("L", "");
            }
            await pollDoc.ref
              .collection("students")
              .doc(studentID)
              .update({ studentVote: newVote });
          }
        }
      } catch (err) {
        if (DEVMODE) {
          console.log(err);
        }
      }
    //}
    await firebase
    .firestore()
    .collection("courses")
    .doc(courseID)
    .collection("students")
    .doc(studentID)
    .update({ locked: "0"});
  } catch (error) {
    console.log("Error getting documents: ", error);
  }
  

};

/*
 Poll-related functions
 */
const getPoll = (pollDoc) => {
  let poll = {};
  poll["pollID"] = pollDoc.id;
  poll["pollStartTime"] = pollDoc.get("pollStartTime");
  poll["pollSessionID"] = pollDoc.get("pollSessionID");
  poll["pollVotedColor"] = pollDoc.get("pollVotedColor");
  poll["pollCategories"] = pollDoc.get("pollCategories");
  poll["activateTime"] = pollDoc.get("activateTime");
  poll["elapsedTime"] = pollDoc.get("elapsedTime");
  poll["answer"] = pollDoc.get("answer");
  poll["pollAnonymous"] = pollDoc.get("pollAnonymous");
  poll["pollLock"] = pollDoc.get("pollLock");
  poll["pollCreatedBy"] = pollDoc.get("pollCreatedBy");

  return poll;
};

export const fetchPolls = (data) => {
  if (DEVMODE) {
    console.log("# polls in session, FetchPolls");
  }
  let sessionID = data.sessionID;
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .where("pollSessionID", "==", sessionID)
      .orderBy("pollStartTime", "asc")
      .get()
      .then((pollDocs) => {
        let polls = {};

        let index = 0;
        pollDocs.forEach((pollDoc) => {
          let poll = getPoll(pollDoc);
          poll["pollIndex"] = ++index;
          polls[pollDoc.id] = poll;
        });

        resolve(polls);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const fetchPoll = (data) => {
  if (DEVMODE) {
    console.log("1 read, fetchPoll");
  }
  let pollID = data.pollID;
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .get()
      .then((pollDoc) => {
        let poll = getPoll(pollDoc);
        resolve(poll);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const fetchPollStudents = (data) => {
  let pollID = data.pollID;
  if (DEVMODE) {
    console.log("1 read + 3*# of students voted in poll, fetchPollStudents");
  }
  return firebase
    .firestore()
    .collection("polls")
    .doc(pollID)
    .collection("students")
    .get()
    .then((querySnapshot) => {
      let students = {};
      querySnapshot.forEach((doc) => {
        students[doc.id] = {
          iClicker: doc.get("iClicker") ? doc.get("iClicker") : "",
          studentVote: doc.get("studentVote"),
          studentCategories: doc.get("studentCategories"),
        };
      });
      return students;
    });
};

export const  fetchPollStudentsAndLock = async (data) =>{
  let pollID = data.pollID;
  const {courseID, sessionID} = data;
  if (DEVMODE) {
    console.log("1 read + 3*# of students voted in poll, fetchPollStudents");
  }
  try {
    const studentsRef = firebase.firestore()
      .collection("polls")
      .doc(pollID)
      .collection("students");

    const querySnapshot = await studentsRef.get();

    if (querySnapshot.empty) {
      //console.log("No students found in the poll.");
      return;
    }
    const batchVotes = firebase.firestore().batch();
    querySnapshot.forEach((doc) => {
      let vote = doc.data().studentVote;
      
      if (!vote.includes("L")) {
        batchVotes.update(doc.ref,{studentVote: "L" + vote})
      }
    })
    await batchVotes.commit();
    const batch = firebase.firestore().batch();
    let studentsString = "";
    let promises = querySnapshot.docs.map(async(doc) => {
      const studentDocRef = firebase.firestore()
        .collection("courses")
        .doc(courseID)
        .collection("students")
        .doc(doc.id);
      const student = await studentDocRef.get();

      if (student.exists) {
        let updateData = { locked: "1" };
        studentsString = studentsString + doc.id + ", ";

        if (sessionID) {
          updateData.lockedSessions = firebase.firestore.FieldValue.arrayUnion(sessionID);
        }
        batch.update(studentDocRef, updateData);
      }
    });
    await Promise.all(promises);
    await batch.commit();
    firebaseLogger({message: "fetchPollStudentsAndLock locked " + studentsString});
    //console.log("Successfully locked students.");
  } catch (error) {
    console.error("Error fetching or updating students:", error);
    throw error;
  }
}; 

export const listenToLock = (data, callback) => {
  let {studentID, courseID} = data;
  const unsubscribe = firebase.firestore().collection("courses").doc(courseID).collection("students").doc(studentID).onSnapshot((snapshot) => {
    if (snapshot.exists) {
      callback(snapshot.data().locked === "1");
    } else {
      callback(false); 
    }
  });
  return unsubscribe;
};

export const  unlockAllStudents = async (data) =>{
  const {courseID} = data;
  if (DEVMODE) {
    console.log("1 read + 3*# of students voted in poll, unlockAllStudents");
  }
  try {
    const studentsRef = firebase.firestore()
      .collection("courses")
      .doc(courseID)
      .collection("students")
      .where("locked", "==", 1);

    const querySnapshot = await studentsRef.get();

    if (querySnapshot.empty) {
      console.log("No students in course.");
      return;
    }

    const batch = firebase.firestore().batch();
    querySnapshot.forEach((doc) => {
      const studentDocRef = firebase.firestore()
        .collection("courses")
        .doc(courseID)
        .collection("students")
        .doc(doc.id);

      let updateData = { locked: "0" };
      batch.update(studentDocRef, updateData);
    });

    await batch.commit();

  } catch (error) {
    console.error("Error fetching or updating students:", error);
    throw error;
  }
} 

export const createPoll = (data) => {
  let pollStartTime = Date.now();
  let pollSessionID = data.pollSessionID;
  let pollVotedColor = data.pollVotedColor;
  let pollCategories = data.pollCategories;
  let pollAnonymous = data.pollAnonymous;
  let pollCreatedBy = data.pollCreatedBy;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .add({
        pollStartTime: pollStartTime,
        pollSessionID: pollSessionID,
        pollVotedColor: pollVotedColor,
        pollCategories: pollCategories,
        pollAnonymous: pollAnonymous,
        pollCreatedBy: pollCreatedBy,
        activateTime: false,
        elapsedTime: 0,
      })
      .then((poll) => {
        resolve(poll.id);
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const updatePollScreenshot = (data) => {
  let pollID = data.pollID;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .update({
        screenshotAvailable: true,
      }).then(() => {
        resolve();
      });
  });
}


export const activatePoll = (data) => {
  if (DEVMODE) {
    console.log("1 read, activatePoll");
  }
  let pollID = data.pollID;
  let activateTime = Date.now();

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .update({
        activateTime: activateTime,
      })
      .then(() => {
        return firebase
          .firestore()
          .collection("polls")
          .doc(pollID)
          .get()
          .then((poll) => {
            return firebase
              .firestore()
              .collection("sessions")
              .doc(poll.get("pollSessionID"))
              .get();
          });
      })
      .then((session) => {
        return firebase
          .firestore()
          .collection("courses")
          .doc(session.get("sessionCourseID"))
          .update({
            courseActivityPollID: pollID,
            courseActivityPollLive: true,
            courseActivityPollDisplay: false,
            courseActivityLastPollTime: activateTime,
          });
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const deactivatePoll = (data) => {
  if (DEVMODE) {
    console.log("1 read, deactivatePoll");
  }
  let courseID = data.courseID;
  let stopCompletely = data.stopCompletely || false;
  let pollID;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .get()
      .then(async (course) => {
        pollID = course.get("courseActivityPollID");
        let poll = await firebase
          .firestore()
          .collection("polls")
          .doc(pollID)
          .get();
        await poll.ref.update({
          elapsedTime:
            Date.now() - poll.get("activateTime") + poll.get("elapsedTime"),
          activateTime: false,
        });
        let pollSettings = { courseActivityPollLive: false };
        if (stopCompletely) {
          pollSettings.courseActivityPollID = false;
          pollSettings.courseActivityPollDisplay = false;
        }
        await course.ref.update(pollSettings);
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const deletePoll = (data) => {
  let pollID = data.pollID;
  let sessionID;
  let accountEmail;
  if (DEVMODE) {
    console.log("1 read + # of students in poll, deletePoll");
  }
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .get()
      .then((pollSnapshot) => {
        return pollSnapshot.ref
          .collection("students")
          .get()
          .then((studentsSnapshot) => {
            if (!studentsSnapshot.empty) {
              studentsSnapshot.forEach((studentSnapshot) => {
                studentSnapshot.ref.delete();
              });
            }
          })
          .then(() => {
            return firebase
              .firestore()
              .collection("sessions")
              .doc(pollSnapshot.get("pollSessionID"))
              .get();
          })
          .then((sessionSnapshot) => {
            sessionID = sessionSnapshot.id;
            return firebase
              .firestore()
              .collection("courses")
              .doc(sessionSnapshot.get("sessionCourseID"))
              .get();
          })
          .then((courseSnapshot) => {
            accountEmail = courseSnapshot.courseInstructorID;
            if (courseSnapshot.get("courseActivityPollID") == pollID) {
              return deactivatePoll({
                courseID: courseSnapshot.id,
                stopCompletely: true,
              });
            }
          })
          .then(() => {
            return pollSnapshot.ref.delete();
          });
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        //alert(err);
      });
  });
};

export const displayPoll = (data) => {
  let courseID = data.courseID;
  let displayPoll = data.displayPoll;
  let pollID = data.pollID;
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .update({
        courseActivityPollDisplay: displayPoll,
        courseActivityPollID: pollID,
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const displayInactivePoll = (data) => {
  let courseID = data.courseID;
  let displayPoll = data.displayPoll;
  let pollID = data.pollID;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("courses")
      .doc(courseID)
      .update({
        courseActivityPollDisplay: displayPoll,
        courseActivityPollID: pollID,
        courseActivityPollLive: false,
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const setPollAnswer = (data) => {
  let pollID = data.pollID;
  let answer = data.answer;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .update({
        answer: answer,
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const setPollLock = (data) => {
  let pollID = data.pollID;
  firebaseLogger({message: "Setting poll " + pollID + " as lockout poll"});
  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .update({
        pollLock: true,
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};


export const listenPollStudents = (data, callback) => {
  /*
     studentID: 'testStudentID' + i,
     studentVote: 'A',
     studentCategories: {
        'testCategoryName': 'testOptionName'
     },
     */
  let pollID = data.pollID;

  return firebase
    .firestore()
    .collection("polls")
    .doc(pollID)
    .collection("students")
    .onSnapshot((querySnapshot) => {
      if (DEVMODE) {
        console.log("# of students in poll * 3 + 1, listenPollStudents");
      }
      let students = {};
      querySnapshot.forEach((doc) => {
        students[doc.id] = {
          iClicker: doc.get("iClicker") ? doc.get("iClicker") : "",
          studentVote: doc.get("studentVote"),
          studentCategories: doc.get("studentCategories"),
        };
      });
      callback(students);
    });
};

export const listenPoll = (data, callback) => {
  let pollID = data.pollID;
  return firebase
    .firestore()
    .collection("polls")
    .doc(pollID)
    .onSnapshot((querySnapshot) => {
      callback({ ...querySnapshot.data(), pollID });
    }, (error) => {
      if (DEVMODE) {
        console.log("Permission denied: ", error);
      }
    });
};

export const resumePoll = (data) => {
  let pollID = data.pollID;

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .get()
      .then((poll) => {
        return firebase
          .firestore()
          .collection("sessions")
          .doc(poll.get("pollSessionID"))
          .get();
      })
      .then((session) => {
        return firebase
          .firestore()
          .collection("courses")
          .doc(session.get("sessionCourseID"))
          .update({
            courseActivityPollID: pollID,
            courseActivityPollLive: true,
            courseActivityPollDisplay: false,
          });
      })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

/* 
 Student-specific functions
 */
export const setPollStudent = (data) => {
  let pollID = data.pollID;
  let studentID = data.studentID;
  let vote = data.vote;
  let studentCategories = undefined;

  if (data.studentCategories !== undefined) {
    studentCategories = data.studentCategories
  }

  return new Promise((resolve, reject) => {
    firebase
      .firestore()
      .collection("polls")
      .doc(pollID)
      .get()
      .then((pollDoc) => {
        firebase
          .firestore()
          .collection("sessions")
          .doc(pollDoc.get("pollSessionID"))
          .get()
          .then((sessionDoc) => {
            firebase
              .firestore()
              .collection("courses")
              .doc(sessionDoc.get("sessionCourseID"))
              .collection("students")
              .doc(studentID)
              .get()
              .then((studentDoc) => {
                firebase
                  .firestore()
                  .collection("polls")
                  .doc(pollID)
                  .collection("students")
                  .doc(studentID)
                  .set({
                    iClicker: studentDoc.get("iClicker")
                      ? studentDoc.get("iClicker")
                      : "",
                    studentVote: vote,
                    studentCategories:
                      studentDoc.get("studentCategories") === undefined
                        ? (studentCategories === undefined ? {} : studentCategories)
                        : studentDoc.get("studentCategories"),
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch((err) => {
                    if (DEVMODE) {
                      console.log(err);
                    }
                  });
              });
          });
      });
  });
};

export const setOverrideStudent = async (data, callback) => {
  let { sessionID, studentID, firstName, lastName, email } = data;

  const studentRef = firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .collection("students");

  try {
    // Check if collection of students exists with session
    const snapShot = await studentRef.get();
    callback(snapShot.empty);

    // Add student to session
    const doc = await studentRef.doc(studentID).get();
    if (doc.exists) {
      return Promise.resolve();
    } else {
      await studentRef.doc(studentID).set({
        firstName: firstName,
        lastName: lastName,
        email: email,
        overrideRequest: false,
        overriden: false,
      });
      return Promise.resolve();
    }
  } catch (err) {
    console.error("Error in setOverrideStudent:", err);
    return Promise.reject(err);
  }
};
export const setLockStudent = async (data, callback) => {
  let { sessionID, studentID, firstName, lastName, email } = data;

  const studentRef = firebase
    .firestore()
    .collection("sessions")
    .doc(sessionID)
    .collection("students");
  try {
    // Check if collection of students exists with session
    const snapShot = await studentRef.get();
    callback(snapShot.empty);

    // Add student to session
    const doc = await studentRef.doc(studentID).get();
  
    if (doc.exists) {
      return Promise.resolve();
    } else if (email) {
      await studentRef.doc(studentID).set({
        firstName: firstName,
        lastName: lastName,
        email: email,
        overridden: false
      });
      return Promise.resolve();
    }
  } catch (err) {
    console.error("Error in setLockStudent:", err);
    return Promise.reject(err);
  }
};

export const saveStudentCourse = (data) => {
  let courseID = data.courseID;
  let accountID = data.accountID;
  let firstName = data.firstName;
  let lastName = data.lastName;

  return new Promise((resolve, reject) => {
    let accountRef = firebase.firestore().collection("accounts").doc(accountID);
    accountRef
      .get()
      .then((accountDoc) => {
        if (accountDoc.exists) {
          accountRef
            .update({
              studentCourses: firebase.firestore.FieldValue.arrayUnion(courseID),
              anonCourses: firebase.firestore.FieldValue.arrayRemove(courseID),
            })
            .then(() => {
              let courseStudentInfo = firebase
                .firestore()
                .collection("courses")
                .doc(courseID)
                .collection("students")
                .doc(accountID);

              courseStudentInfo
                .get()
                .then((snapshot) => {
                  if (snapshot.exists) {
console.log("HERE");
                    if (snapshot.get("archived")) {
                      courseStudentInfo.update({ archived: false}).then(() => {
                        resolve();
                      });
                    } else {
                      resolve();
                    }
                  } else {
                    courseStudentInfo
                      .set({
                        studentCategories: {},
                        firstName: firstName,
                        lastName: lastName,
                        // identifier:
                        //   accountDoc.get("identifier") === undefined
                        //     ? ""
                        //     : accountDoc.get("identifier"),
                      })
                      .then(() => {
                        resolve();
                      })
                      .catch((err) => {
                        if (DEVMODE) {
                          console.log(err);
                        }
                      });
                  }
                })
                .catch((err) => {
                  if (DEVMODE) {
                    console.log(err);
                  }
                });
            })
            .catch((err) => {
              if (DEVMODE) {
                console.log(err);
              }
            });
        } else {
          // Document does not exist
          firebase
            .app()
            .firestore()
            .collection("accounts")
            .doc(accountID)
            .set({
              firstName: firstName,
              lastName: lastName,
              // identifier: accountID,
              studentCourses: [courseID],
              type: "student",
            })
            .then(() => {
              let courseStudentInfo = firebase
                .firestore()
                .collection("courses")
                .doc(courseID)
                .collection("students")
                .doc(accountID);

              courseStudentInfo
                .get()
                .then((snapshot) => {
                  if (snapshot.exists) {
                    resolve();
                  } else {
                    courseStudentInfo
                      .set({
                        studentCategories: {},
                        firstName: firstName,
                        lastName: lastName,
                        // identifier:
                        //   accountDoc.get("identifier") === undefined
                        //     ? ""
                        //     : accountDoc.get("identifier"),
                      })
                      .then(() => {
                        resolve();
                      })
                      .catch((err) => {
                        if (DEVMODE) {
                          console.log(err);
                        }
                      });
                  }
                })
                .catch((err) => {
                  if (DEVMODE) {
                    console.log(err);
                  }
                });
            })
            .catch((err) => {
              if (DEVMODE) {
                console.log(err);
              }
            });
        }
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const updateCourseStudent = (data) => {
  let courseID = data.courseID;
  let accountID = data.accountID;
  let iClicker = data.iClicker;

  return new Promise((resolve, reject) => {
    let accountRef = firebase.firestore().collection("accounts").doc(accountID);

    accountRef
      .get()
      .then(async (accountDoc) => {
        if (accountDoc.get("studentCourses").indexOf(courseID) === -1) {
          reject();
        }
        let courseStudentRef = firebase
          .firestore()
          .collection("courses")
          .doc(courseID)
          .collection("students")
          .doc(accountID);
        return courseStudentRef.get();
      })
      .then(async (courseStudentSnapshot) => {
        await courseStudentSnapshot.ref.update({ iClicker: iClicker });
        return Promise.resolve(courseStudentSnapshot);
      })
      .then(async (courseStudentSnapshot) => {
        if (!iClicker) {
          resolve();
          return;
        }
        let unlinkedVotesSnapshot = await firebase
          .firestore()
          .collection("courses")
          .doc(courseID)
          .collection("unlinkedVotes")
          .doc(iClicker)
          .get();
        if (!unlinkedVotesSnapshot.exists) {
          resolve();
          return;
        }
        let polls = unlinkedVotesSnapshot.get("polls");
        if (!polls.length) {
          resolve();
          return;
        }
        for (const pollID of polls) {
          let unlinkedVoteSnapshot = await firebase
            .firestore()
            .collection("polls")
            .doc(pollID)
            .collection("students")
            .doc(iClicker)
            .get();
          await firebase
            .firestore()
            .collection("polls")
            .doc(pollID)
            .collection("student")
            .doc(accountID)
            .set({
              iClicker: iClicker,
              studentVote: unlinkedVoteSnapshot.get("studentVote"),
              studentCategories: courseStudentSnapshot.get("studentCategories"),
            });
          unlinkedVoteSnapshot.ref.delete();
        }
        unlinkedVotesSnapshot.ref.delete();
        resolve();
      })
      .catch((err) => {
        if (DEVMODE) {
          console.log(err);
        }
      });
  });
};

export const updateCourseStudentIdentifier = (data) => {
  let { accountID, identifier } = data;
  
  firebase
    .firestore()
    .collection("accounts")
    .doc(accountID)
    .get()
    .then((accountSnapshot) => {
      const studentCourses = accountSnapshot.data().studentCourses;

      if (Array.isArray(studentCourses)) {
        // Iterate over each courseID in the studentCourses array
        studentCourses.forEach((courseID) => {
          firebase
            .firestore()
            .collection("courses")
            .doc(courseID)
            .collection("students")
            .doc(accountID)
            .set({ identifier: identifier }, { merge: true })
            .then(() => {
              if (DEVMODE)
                console.log(`Updated identifier for course ${courseID}`);
            })
            .catch((error) => {
              if (DEVMODE)
                console.error(`Failed to update course ${courseID}:`, error);
            });
        });
      } else {
        if (DEVMODE) console.error("studentCourses is not an array");
      }
    })
    .catch((error) => {
      if (DEVMODE) console.error("Failed to retrieve account data:", error);
    });
};

export const fetchAccountDoc = (data) => {
  let accountID = data.accountID;

  return firebase.firestore().collection("accounts").doc(accountID).get();
};

export const getScreenshotURLs = (data) => {
  let accountEmail = data.accountEmail;
  let sessionID = data.sessionID;
  let ordered = data.ordered || false;

  let URLs = {};
  let storageRef = firebase
    .storage()
    .ref(`screenshots/${accountEmail}/${sessionID}`);
  return storageRef.listAll().then(async (response) => {
    let { prefixes } = response;
    let promises = [];
    prefixes.forEach((p) => {
      let path = `${p._delegate._location.path_}/image`;
      let promise = firebase
        .storage()
        .ref(path)
        .getDownloadURL()
        .then((url) => {
          let pollID = p._delegate._location.path_.split("/").slice(-1)[0];
          URLs[pollID] = url;
        });
      promises.push(promise);
    });
    await Promise.all(promises);

    if (ordered) {
      await firebase
        .firestore()
        .collection("polls")
        .where("pollSessionID", "==", sessionID)
        .get()
        .then((pollSnapshots) => {
          let pollOrdering = [];
          pollSnapshots.forEach((p) =>
            pollOrdering.push([p.id, p.get("pollStartTime")])
          );
          pollOrdering.sort((a, b) => a[1] - b[1]);

          let orderedURLs = [];
          if (DEVMODE) {
            console.log(URLs);
            console.log(pollOrdering);
          }
          pollOrdering.forEach((p) => {
            orderedURLs.push(URLs[p[0]]);
          });
          URLs = orderedURLs;
        });
    }
    if (DEVMODE) {
      console.log(URLs);
    }
    return URLs;
  });
};

export const setAuthCourseID = (courseID) => {
  return new Promise((resolve, reject) => {
    const setCourse = httpsCallable(getFunctions(), 'setUserCourse');
    const auth = getAuth();
    setCourse({courseID: courseID}).then(async () => {
      await getIdTokenResult(auth.currentUser, true).then((result) => {
        console.log("setUserCourse ran, course: ", result.claims.selectedCourse);
        resolve();
      });
    }).catch((error) => {
      console.log("setUserCourse failed: ", error);
      reject();
    });
  });
};

export const getStudentLockedSessions = async (data) => {
  let courseID = data.courseID;
  let studentEmail = data.studentEmail;
  const sessions = await firebase
    .firestore()
    .collection("sessions")
    .where("sessionCourseID", "==", courseID)
    .orderBy("sessionStartTime")
    .get();
  let lockedSessions = {};
  let sessionNum = 1;

  for (const session of sessions.docs) {
    const student = await firebase
      .firestore()
      .collection("sessions")
      .doc(session.id)
      .collection("students")
      .doc(studentEmail)
      .get(); 

    if (student.exists) {
      const polls = await firebase 
        .firestore()
        .collection("polls")
        .where("pollSessionID", "==", session.id)
        .get();
      let sessionData = {
        sessionNum: sessionNum,
        lockoutPoll: false,
        date: convertUnixToDate(session.get("sessionStartTime")),
      };
      let studentVoted = false;

      for (const poll of polls.docs) {
        const studentDoc = await poll.ref.collection("students").doc(studentEmail).get();

        if (studentDoc.exists && studentDoc.data().studentVote.includes("L")) {
          studentVoted = true;

          if (poll.get("pollLock")) {
            sessionData["lockoutPoll"] = true;
          }
        }
      }

      if (studentVoted === true) {
        lockedSessions[session.id] = sessionData;
      }
    }
    sessionNum++;
  }
  return lockedSessions;
};

export const unlockSelSessions = async(data) => {
  let selSessions = data.selSessions;
  let courseID = data.courseID;
  let studentEmail = data.studentEmail;
  let sessionPromises = selSessions.map(async(sessionID) => {
    const polls = await firebase
      .firestore()
      .collection("polls")
      .where("pollSessionID", "==", sessionID)
      .get();
    let pollPromises = polls.docs.map(async(poll) => {
      const studentDoc = await firebase
        .firestore()
        .collection("polls")
        .doc(poll.id)
        .collection("students")
        .doc(studentEmail)
        .get();

      if (studentDoc.exists && studentDoc.get("studentVote").includes("L")) {
        let newVote = "";

        if (poll.data().pollAnonymous) {
          newVote = studentDoc.data().studentVote.includes("X")
            ? studentDoc.data().studentVote.replace("L", "")
            : studentDoc.data().studentVote.replace("L", "X");
        } else {
          newVote = studentDoc.data().studentVote.replace("L", "");
        }
        studentDoc.ref.update({ studentVote: newVote });
      }
    });
    await Promise.all(pollPromises);
  });
  await Promise.all(sessionPromises);
  await firebase
    .firestore()
    .collection("courses")
    .doc(courseID)
    .collection("students")
    .doc(studentEmail)
    .update({ locked: "0"});
};

export const getScreenshotDevices = async(data) => {
  let email = data.email;
  const userData = await firebase
    .firestore()
    .collection("accounts")
    .doc(email)
    .get();
  
  if (userData.exists && userData.get("screenshotDevices")) {
    return userData.data().screenshotDevices;
  }
  return {};
};

export const setScreenshotDevices = async(data) => {
  let email = data.email;
  let screenshotDevices = data.screenshotDevices;

  await firebase
    .firestore()
    .collection("accounts")
    .doc(email)
    .update({
      screenshotDevices: screenshotDevices,
    });
};

export const getCourseAdminView = async(doc) => {
  let course = getCourse(doc);
  const studentSnapshot = await getCountFromServer(collection(firebase.firestore(), "courses", doc.id, "students"));
  course["totStudents"] = studentSnapshot.data().count;
  const sessions = await getDocs(query(collection(firebase.firestore(), "sessions"), where("sessionCourseID", "==", doc.id), orderBy("sessionStartTime", "desc")));
  // const sessions = await firebase
  //   .firestore()
  //   .collection("sessions")
  //   .where("sessionCourseID", "==", doc.id)
  //   .orderBy("sessionStartTime", "desc")
  //   .get();
  course["totSessions"] = sessions.size;

  // console.log("polls time");

  const promises = sessions.docs.map(async(session) => {
    // console.log(session.id);
    try {
      const pollsSnapshot = await getCountFromServer(query(collection(firebase.firestore(), "polls"), where("pollSessionID", "==", session.id)))
      // console.log(session.id);
      return pollsSnapshot.data().count;
    } catch (error) {
      console.log(error);
      // return 0;
    }
  });
  // console.log("heyo");
  const pollCounts = await Promise.all(promises);
  // console.log("done done done");
  course["totPolls"] = pollCounts.reduce((accum, currVal) => accum + currVal, 0);
  course["lastPoll"] = 0;
  course["courseCreated"] = course.courseCreated ?? 0;
  course["starred"] = course.starred ?? false;
  course["anonymousCourse"] = course.anonymousCourse ?? false;
  course["markedForArchive"] = course.markedForArchive ?? false;
  // console.log("last poll");

  if (sessions.size > 0) {
    const lastPoll = await firebase
      .firestore()
      .collection("polls")
      .where("pollSessionID", "==", sessions.docs[0].id)
      .orderBy("pollStartTime", "desc")
      .limit(1)
      .get();
  
    if (lastPoll.size == 1) {
      course["lastPoll"] = lastPoll.docs[0].data().pollStartTime;
    }
  }
  return course;
};

export const filterCourses = async(data) => {
  let query = firebase
    .firestore()
    .collection("courses");
    
  if (!data.filterAllCourses) {

    if (data.filterCourse) {
      query = query.where("courseName", "==", data.filterCourse);
    }
    
    if (data.filterTerm) {
      query = query.where("courseTerm", "==", data.filterTerm);
    }

    if (data.filterInstructor) {
      query = query.where("courseInstructorID", "==", data.filterInstructor);
    }

    if (data.filterCourseCreateBefore) {
      query = query.where("courseCreated", "<", data.filterCourseCreateBefore);
    }

    if (data.filterCourseCreateAfter) {
      query = query.where("courseCreated", ">", data.filterCourseCreateAfter);
    }

    if (data.filterLastPoll) {
      query = query.where("courseActivityLastPollTime", "<", data.filterLastPoll);
    }

    if (data.filterStudentsLessThan) {
      console.log("HIHI");
      query = query.where("totStudents", "<", parseInt(data.filterStudentsLessThan));
    }

    if (data.filterStudentsGreaterThan) {
      console.log(data.filterStudentsGreaterThan);
      query = query.where("totStudents", ">", parseInt(data.filterStudentsGreaterThan)).limit(2);
    }

    if (data.filterActive !== "both") {
      console.log("HI");
      query = query.where("isActive", "==", data.filterActive === "active" ? true : false);
    }

    if (data.filterAnonymous !== "both") {
      query = query.where("anonymousCourse", "==", data.filterAnonymous === "anonymous" ? true : false);
    }

    if (data.filterStarred !== "both") {
      console.log("HIyo");
      query = query.where("starred", "==", data.filterStarred === "starred" ? true : false);
    }
  }
  
  const filteredCourses = await query.get();
  let courses = {};
  // const promises = filteredCourses.docs.map(async(doc) => {
  //   let course = await getCourseAdminView(doc);
  //   courses[doc.id] = course;
  // })
  // await Promise.all(promises);
  let start = 0;

  while (start != filteredCourses.docs.length) {
    const currBatch = filteredCourses.docs.slice(start, start+20);
    // console.log(currBatch);
    start += currBatch.length;
    const promises = currBatch.map(async(doc) => {
      let course = await getCourseAdminView(doc);
      courses[doc.id] = course;
    })
    await Promise.all(promises);
  }
  return courses;
  // return {};
};

export const updateCourseAdminSettings = async(data) => {
  await firebase
    .firestore()
    .collection("courses")
    .doc(data.courseID)
    .update({
      starred: data.starred,
      maxTAs: data.maxTAs,
      isActive: data.isActive,
      markedForArchive: data.markedForArchive,
      notifyArchive: data.notifyArchive,
    });
};

export const createCustomFilter = async(data) => {
  let filterID = data.filterID;
  const userEmail = data.userEmail;
  delete data["filterID"];
  delete data["userEmail"];

  if (filterID) {
    await firebase
      .firestore()
      .collection("accounts")
      .doc(userEmail)
      .collection("filters")
      .doc(filterID)
      .update(data);  
  } else {
    const filter = await firebase
      .firestore()
      .collection("accounts")
      .doc(userEmail)
      .collection("filters")
      .add(data);  
    filterID = filter.id;
  }
  return filterID;
};

export const getFilters = async(data) => {
  const results = await firebase
    .firestore()
    .collection("accounts")
    .doc(data.userEmail)
    .collection("filters")
    .get();
  let filters = {};
  results.forEach((filter) => {
    filters[filter.id] = {...filter.data()}
  });
  return filters;
};

export const deleteFilter = async(data) => {
  await firebase
    .firestore()
    .collection("accounts")
    .doc(data.userEmail)
    .collection("filters")
    .doc(data.filterID)
    .delete();
};

export const stopArchiveNotify = async(data) => {

  if (data.courses.length === 0) return; 

  const batch = firebase.firestore().batch();
  for (const id of data.courses) {
    batch.update(firebase.firestore().collection("courses").doc(id), {notifyArchive: false});
  }
  await batch.commit();
}

export const convertToTAType = async(data) => {
  const accounts = data.accounts;
  const accountDocs = await firebase 
    .firestore()
    .collection("accounts")
    .where(firebase.firestore.FieldPath.documentId(), "in", accounts)
    .get();
  const batch = firebase.firestore().batch();
  accountDocs.forEach((doc) => {
    if (doc.data().type === "student") {
      batch.update(doc.ref, { type: "ta" });
    }
  });
  await batch.commit();
};

export const checkRemovedTAs = async(data) => {
  const accounts = data.accounts;

  const promises = accounts.map(async(account) => {
    // const courseData = firebase
    //   .firestore()
    //   .collection("courses")
    //   .where("tas", "array-contains", account)
    //   .count()
    //   .get();
    const results = await getCountFromServer(query(collection(firebase.firestore(), "courses"), where("tas", "array-contains", account), where("isActive", "==", true)));

    if (results.data().count === 0) {
      const accountDoc = await firebase
        .firestore()
        .collection("accounts")
        .doc(account)
        .get();
      
      if (accountDoc.data().type === "ta") {
        await accountDoc.ref.update({ type: "student" });
      }
    }
  });
  await Promise.all(promises);
};

export const clearStudentRoster = async(data) => {
  const courseID = data.courseID;
  const students = await firebase
    .firestore()
    .collection("courses")
    .doc(courseID)
    .collection("students")
    .get();

  const batch = firebase.firestore().batch();
  let promises = students.docs.map(async(student) => {
    const studentData = await firebase
      .firestore()
      .collection("accounts")
      .doc(student.id)
      .get();
    let newAnonCourses = studentData.data().anonCourses ?? [];
    console.log(newAnonCourses);
    newAnonCourses.push(courseID);
    let newCourses = studentData.data().studentCourses.filter((course) => course !== courseID);
    batch.update(studentData.ref, {anonCourses: newAnonCourses, studentCourses: newCourses});
  });
  await Promise.all(promises);
  batch.commit();
}

export const fetchAnonCourses = async(data) => {
  let studentData = await firebase
    .firestore()
    .collection("accounts")
    .doc(data.accountID)
    .get();

  if (!studentData.exists) {
    return {};
  }
  const anonCourseIDs = studentData.data().anonCourses;

  if (!anonCourseIDs || anonCourseIDs.length === 0) {
    return {};
  }
  const anonCourses = await firebase
    .firestore()
    .collection("courses")
    .where(firebase.firestore.FieldPath.documentId(), "in", anonCourseIDs)
    .orderBy("courseName", "asc")
    .get();
  let retCourses = {};
  anonCourses.docs.forEach((course) => {
    retCourses[course.id] = getCourse(course);
  });
  console.log(retCourses);
  return retCourses;
}

export const reenrollStudents = async(data) => {
  const courseID = data.courseID;
  const students = await firebase
    .firestore()
    .collection("accounts")
    .where("anonCourses", "array-contains", courseID)
    .get();
  const batch = firebase.firestore().batch();
  let promises = students.docs.map((student) => {
    batch.update(firebase.firestore().collection("accounts").doc(student.id), {
      anonCourses: firebase.firestore.FieldValue.arrayRemove(courseID),
      studentCourses: firebase.firestore.FieldValue.arrayUnion(courseID)});
  });
  await Promise.all(promises);
  batch.commit();
};

export const archiveStudentCourse = async(data) => {
  let email = data.email;
  let courseID = data.courseID;
  const studentDoc = await firebase
    .firestore()
    .collection("accounts")
    .doc(email)
    .get();

  if (studentDoc.exists) {
    let courses = studentDoc.data().studentCourses ?? [];
    const index = courses.indexOf(courseID);

    if (index > -1) {
      courses.splice(index, 1);
      const studentCourseDoc = firebase
        .firestore()
        .collection("courses")
        .doc(courseID)
        .collection("students")
        .doc(email);

        if ((await studentCourseDoc.get()).exists) {
          await studentCourseDoc.update({ archived: true });
        }
        await studentDoc.ref.update({studentCourses: courses});
    }
  }
};

export const addInstructor = async(data) => {
  const userDoc = firebase
    .firestore()
    .collection("accounts")
    .doc(data.email);
  
  if (!(await userDoc.get()).exists) {
    await userDoc.set({ manuallyAdded : true, type: "instructor" });
    return true;
  } else {
    return false;
  }
};
